<!--======= Banner Form Start Here ========-->
<div class="overflow">
    <div id="main-wrapper">
        <div class="site-wrapper-reveal">
            <div class="position-rela.tive w-100">
                <div class="d-flex align-items-center w-100">
                    <img src="../../../assets/images/banners/work-banner.png"
                        class="img img-responsive w-100 h-100 d-none d-md-block" width="100%" alt="application" />
                    <img src="../../../assets/images/banners/work-mobile.png"
                        class="img img-responsive d-block d-md-none" width="100%" alt="mobile career banner" />
                    <div class="position-absolute w-100 home-banner">
                        <div class="row h-100 w-100">
                            <div class="col-8 col-md-4 col-sm-6 banner-section">
                                <div class="align-items-center banner-content-title  global_title global_banner_title  title_banner_content  banner-content-title1"
                                    role="heading" aria-level="1">
                                    <span>Work with us</span>
                                </div>
                                <div class="global_sub_title global_banner_subtitle mt-3 global_sub_title2"
                                    role="heading" aria-level="1">
                                    <span>Be a part of a growing technology organizations that's revolutionizing
                                        industries.</span>
                                </div>
                                <div class="col pt-lg-3  mt-lg-3 global_button1">
                                    <a href="contact" class="global_button text-left col text-white white_button"
                                        role="button" aria-label="View Contact Page">
                                        <div class="dub-arrow"><img src="../../../assets/images/button/arrowWhite.png"
                                                alt="contact " /></div>
                                        CONTACT US
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--======= Banner End Here ========-->
    <div class="container-fluid ">
        <div class="container py-3 pt-5">
            <div class="row mt-2">
                <div class="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7">
                    <div class="job-heading">
                        <div class="mit-red  text-black mb-4"> UI Developer </div>
                        <p class="global_section_content">
                            Maganti IT Resources LLC is seeking one professional for a fulltime employment (40 hours/week) for a UI Developer position at Waterbury, CT.</p>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 d-flex align-items-center Digital">
                    <a href="#" role="button" aria-label="Open pro1" tabindex="-1"
                        class="btn-hover mt-1 px-5 py-3 mx-auto d-block" data-toggle='modal' data-target='#pspa37'
                        id="modal37">
                        <p hidden>pro</p>
                        <em></em>
                    </a>
                    <span>
                        <a href="#" role="button" class="global_button   text-left " data-bs-toggle="modal"
                            data-bs-target="#uiDeveloper">
                            <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png"
                                    alt="BA Details" /></div>
                            MORE DETAILS
                        </a>
                    </span>
                </div>
            </div>
            <div class="row mt-5 mb-3">
                <div class="col-12 col-sm-12 col-md-3 col-lg-4 col-xl-4">
                    <div class="career-bottom">
                        <div>
                            <p class="text-blue global_section_content career_subsection">Full Time</p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                    <div class="career-bottom">
                        <div>
                            <p class="text-blue global_section_content career_subsection">
                                <i class="fa fa-map-marker-alt"></i>
                                Location : Waterbury, CT 06702
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid career-bg">
        <div class="container py-3 pt-5">
            <div class="row mt-2">
                <div class="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7">
                    <div class="job-heading">
                        <div class="mit-red  text-black mb-4">Software Engineer  </div>
                        <p class="global_section_content">
                            Maganti IT Resources, LLC is looking for a full-time Software Engineer.</p>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 d-flex align-items-center Digital">
                    <a href="#" role="button" aria-label="Open pro1" tabindex="-1"
                        class="btn-hover mt-1 px-5 py-3 mx-auto d-block" data-toggle='modal' data-target='#pspa37'
                        id="modal37">
                        <p hidden>pro</p>
                        <em></em>
                    </a>
                    <span>
                        <a href="#" role="button" class="global_button   text-left " data-bs-toggle="modal"
                            data-bs-target="#myModalSoftEngg">
                            <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png"
                                    alt="Aem Developer Details" /></div>
                            MORE DETAILS
                        </a>
                    </span>
                </div>
            </div>
            <div class="row mt-5 mb-3">
                <div class="col-12 col-sm-12 col-md-3 col-lg-4 col-xl-4">
                    <div class="career-bottom">
                        <div>
                            <p class="text-blue global_section_content career_subsection">Full Time</p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                    <div class="career-bottom">
                        <div>
                            <p class="text-blue global_section_content career_subsection">
                                <i class="fa fa-map-marker-alt"></i>
                                Location : Waterbury, CT 06702
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid ">
        <div class="container py-3 pt-5">
            <div class="row mt-2">
                <div class="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7">
                    <div class="job-heading">
                        <div class="mit-red  text-black mb-4">  Software Developer </div>
                        <p class="global_section_content">
                            Maganti IT Resources LLC is seeking one professional for a fulltime employment (40 hours/week) for a Software Developer position at Waterbury, CT. </p>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 d-flex align-items-center Digital">
                    <a href="#" role="button" aria-label="Open pro1" tabindex="-1"
                        class="btn-hover mt-1 px-5 py-3 mx-auto d-block" data-toggle='modal' data-target='#pspa37'
                        id="modal37">
                        <p hidden>pro</p>
                        <em></em>
                    </a>
                    <span>
                        <a href="#" role="button" class="global_button   text-left " data-bs-toggle="modal"
                            data-bs-target="#Softwarejobpost">
                            <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png"
                                    alt="BA Details" /></div>
                            MORE DETAILS
                        </a>
                    </span>
                </div>
            </div>
            <div class="row mt-5 mb-3">
                <div class="col-12 col-sm-12 col-md-3 col-lg-4 col-xl-4">
                    <div class="career-bottom">
                        <div>
                            <p class="text-blue global_section_content career_subsection">Full Time</p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                    <div class="career-bottom">
                        <div>
                            <p class="text-blue global_section_content career_subsection">
                                <i class="fa fa-map-marker-alt"></i>
                                Location : Waterbury, CT 06702
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid career-bg">
        <div class="container py-3 pt-5">
            <div class="row mt-2">
                <div class="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7">
                    <div class="job-heading">
                        <div class="mit-red  text-black mb-4"> Sr. DotNet Developer </div>
                        <p class="global_section_content">
                            Maganti IT Resources LLC is seeking one professional for a full-time employment (40 hours a week) for 
                            the position of Sr. DotNet Developer at competitive salary. </p>
                        </div>
                </div>
                <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 d-flex align-items-center Digital">
                    <a href="#" role="button" aria-label="Open pro1" tabindex="-1"
                        class="btn-hover mt-1 px-5 py-3 mx-auto d-block" data-toggle='modal' data-target='#pspa37'
                        id="modal37">
                        <p hidden>pro</p>
                        <em></em>
                    </a>
                    <span>
                        <a href="#" role="button" class="global_button   text-left " data-bs-toggle="modal"
                            data-bs-target="#modalSeniorDotNet">
                            <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png"
                                    alt="Aem Developer Details" /></div>
                            MORE DETAILS
                        </a>
                    </span>
                </div>
            </div>
            <div class="row mt-5 mb-3">
                <div class="col-12 col-sm-12 col-md-3 col-lg-4 col-xl-4">
                    <div class="career-bottom">
                        <div>
                            <p class="text-blue global_section_content career_subsection">Full Time</p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                    <div class="career-bottom">
                        <div>
                            <p class="text-blue global_section_content career_subsection">
                                <i class="fa fa-map-marker-alt"></i>
                                Location : Waterbury, CT 06702
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid ">
        <div class="container py-3 pt-5">
            <div class="row mt-2">
                <div class="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7">
                    <div class="job-heading">
                        <div class="mit-red  text-black mb-4"> .NET Programmer  </div>
                        <p class="global_section_content">
                            Maganti IT Resources LLC is seeking one professional for a full-time employment (40 hours a week) for the position of a .NET Programmer at a competitive salary. </p>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 d-flex align-items-center Digital">
                    <a href="#" role="button" aria-label="Open pro1" tabindex="-1"
                        class="btn-hover mt-1 px-5 py-3 mx-auto d-block" data-toggle='modal' data-target='#pspa37'
                        id="modal37">
                        <p hidden>pro</p>
                        <em></em>
                    </a>
                    <span>
                        <a href="#" role="button" class="global_button   text-left " data-bs-toggle="modal"
                            data-bs-target="#myModalNet">
                            <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png"
                                    alt="BA Details" /></div>
                            MORE DETAILS
                        </a>
                    </span>
                </div>
            </div>
            <div class="row mt-5 mb-3">
                <div class="col-12 col-sm-12 col-md-3 col-lg-4 col-xl-4">
                    <div class="career-bottom">
                        <div>
                            <p class="text-blue global_section_content career_subsection">Full Time</p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                    <div class="career-bottom">
                        <div>
                            <p class="text-blue global_section_content career_subsection">
                                <i class="fa fa-map-marker-alt"></i>
                                Location : Waterbury, CT 06702
                            </p>
                        </div>
                    </div>
                </div>
              
                
            </div>
        </div>
    </div>
   

    <div class="container-fluid career-bg">
        <div class="container py-3 pt-5">
            <div class="row mt-2">
                <div class="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7">
                    <div class="job-heading">
                        <div class="mit-red  text-black mb-4"> Business Analyst </div>
                        <p class="global_section_content">
                            Maganti IT Resources LLC is seeking one professional for the full-time position of a
                            Analyst at a competitive salary for our Waterbury, CT office.</p>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 d-flex align-items-center Digital">
                    <a href="#" role="button" aria-label="Open pro1" tabindex="-1"
                        class="btn-hover mt-1 px-5 py-3 mx-auto d-block" data-toggle='modal' data-target='#pspa37'
                        id="modal37">
                        <p hidden>pro</p>
                        <em></em>
                    </a>
                    <span>
                        <a href="#" role="button" class="global_button   text-left " data-bs-toggle="modal"
                            data-bs-target="#myModalBa">
                            <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png"
                                    alt="BA Details" /></div>
                            MORE DETAILS
                        </a>
                    </span>
                </div>
            </div>
            <div class="row mt-5 mb-3">
                <div class="col-12 col-sm-12 col-md-3 col-lg-4 col-xl-4">
                    <div class="career-bottom">
                        <div>
                            <p class="text-blue global_section_content career_subsection">Full Time</p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                    <div class="career-bottom">
                        <div>
                            <p class="text-blue global_section_content career_subsection">
                                <i class="fa fa-map-marker-alt"></i>
                                Location : Waterbury, CT 06702
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="container-fluid ">
        <div class="container py-3 pt-5">
            <div class="row mt-2">
                <div class="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7">
                    <div class="job-heading">
                        <div class="mit-red  text-black mb-4">Software Developer</div>
                        <p class="global_section_content">
                            Maganti IT Resources LLC is seeking one professional for a fulltime employment (40 hours/week) for a Software Developer position at Waterbury, CT.</p>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 d-flex align-items-center Digital">
                    <a href="#" role="button" aria-label="Open pro1" tabindex="-1"
                        class="btn-hover mt-1 px-5 py-3 mx-auto d-block" data-toggle='modal' data-target='#pspa37'
                        id="modal37">
                        <p hidden>pro</p>
                        <em></em>
                    </a>
                    <span>
                        <a href="#" role="button" class="global_button   text-left " data-bs-toggle="modal"
                            data-bs-target="#myModalSd">
                            <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png"
                                    alt="Software developer Details" /></div>
                            MORE DETAILS
                        </a>
                    </span>
                </div>
            </div>
            <div class="row mt-5 mb-3">
                <div class="col-12 col-sm-12 col-md-3 col-lg-4 col-xl-4">
                    <div class="career-bottom">
                        <div>
                            <p class="text-blue global_section_content career_subsection">Full Time</p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                    <div class="career-bottom">
                        <div>
                            <p class="text-blue global_section_content career_subsection">
                                <i class="fa fa-map-marker-alt"></i>
                                Location : Waterbury, CT 06702
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
    
  
    <div class="container-fluid ">
        <div class="container py-3 pt-5">
            <div class="row mt-2">
                <div class="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7">
                    <div class="job-heading">
                        <div class="mit-red  text-black mb-4">AEM Developer </div>
                        <p class="global_section_content">
                            Maganti IT Resources LLC is seeking one professional employment with 40 hours a week for the
                            position of AEM Developer at a competitive salary.</p>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 d-flex align-items-center Digital">
                    <a href="#" role="button" aria-label="Open pro1" tabindex="-1"
                        class="btn-hover mt-1 px-5 py-3 mx-auto d-block" data-toggle='modal' data-target='#pspa37'
                        id="modal37">
                        <p hidden>pro</p>
                        <em></em>
                    </a>
                    <span>
                        <a href="#" role="button" class="global_button   text-left " data-bs-toggle="modal"
                            data-bs-target="#myModalAem">
                            <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png"
                                    alt="Aem Developer Details" /></div>
                            MORE DETAILS
                        </a>
                    </span>
                </div>
            </div>
            <div class="row mt-5 mb-3">
                <div class="col-12 col-sm-12 col-md-3 col-lg-4 col-xl-4">
                    <div class="career-bottom">
                        <div>
                            <p class="text-blue global_section_content career_subsection">Full Time</p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                    <div class="career-bottom">
                        <div>
                            <p class="text-blue global_section_content career_subsection">
                                <i class="fa fa-map-marker-alt"></i>
                                Location : Waterbury, CT 06702
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid career-bg">
        <div class="container py-3 pt-5">
            <div class="row mt-2">
                <div class="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7">
                    <div class="job-heading">
                        <div class="mit-red  text-black mb-4">Engineering Manager, DevOps</div>
                        <p class="global_section_content">
                            Maganti IT Resources, LLC is looking for a full-time Engineering Manager, DevOps.</p>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 d-flex align-items-center Digital">
                    <a href="#" role="button" aria-label="Open pro1" tabindex="-1"
                        class="btn-hover mt-1 px-5 py-3 mx-auto d-block" data-toggle='modal' data-target='#pspa37'
                        id="modal37">
                        <p hidden>pro</p>
                        <em></em>
                    </a>
                    <span>
                        <a href="#" role="button" class="global_button   text-left " data-bs-toggle="modal"
                            data-bs-target="#myModalEngineerDevops">
                            <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png"
                                    alt="Engineer Devops Details" /></div>
                            MORE DETAILS
                        </a>
                    </span>
                </div>
            </div>
            <div class="row mt-5 mb-3">
                <div class="col-12 col-sm-12 col-md-3 col-lg-4 col-xl-4">
                    <div class="career-bottom">
                        <div>
                            <p class="text-blue global_section_content career_subsection">Full Time</p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                    <div class="career-bottom">
                        <div>
                            <p class="text-blue global_section_content career_subsection">
                                <i class="fa fa-map-marker-alt"></i>
                                Location : Waterbury, CT 06702
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container-fluid ">
        <div class="container py-3 pt-5">
            <div class="row mt-2">
                <div class="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7">
                    <div class="job-heading">
                        <div class="mit-red  text-black mb-4">Web QA/BA Automation tester</div>
                        <p class="global_section_content">
                            Maganti IT Resources LLC is seeking one professional for Fulltime employment (40 hours/week)
                            for a Web QA/BA Automation tester position at Waterbury, CT 06702.</p>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 d-flex align-items-center Digital">
                    <a href="#" role="button" aria-label="Open pro" tabindex="-1"
                        class="btn-hover mt-1 px-5 py-3 mx-auto d-block" data-toggle='modal' data-target='#pspa37'
                        id="modal37">
                        <p hidden>pro</p>
                        <em></em>
                    </a>
                    <span>
                        <a href="#" class="global_button   text-left " role="button" aria-label="Open Contact Us Form"
                            tabindex="0" data-bs-toggle="modal" data-bs-target="#myModalTester">
                            <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png"
                                    alt="Arrow pointing towards more details" /></div>
                            MORE DETAILS
                        </a>
                    </span>
                </div>
            </div>
            <div class="row mt-5 mb-3">
                <div class="col-12 col-sm-12 col-md-3 col-lg-4 col-xl-4">
                    <div class="career-bottom">
                        <div>
                            <p class="text-blue global_section_content career_subsection">Full Time</p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                    <div class="career-bottom">
                        <div>
                            <p class="text-blue global_section_content career_subsection">
                                <i class="fa fa-map-marker-alt"></i>
                                Location : Waterbury, CT 06702
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid career-bg">
        <div class="container py-3 pt-5">
            <div class="row mt-2">
                <div class="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7">
                    <div class="job-heading">
                        <div class="mit-red  text-black mb-4">Angular JS Developer </div>
                        <p class="global_section_content">
                            Maganti IT Resources LLC is seeking one professional for Fulltime employment (40 hours/week)
                            for a Angular JS Developer position at Waterbury, CT 06702.</p>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 d-flex align-items-center Digital">
                    <a href="#" role="button" aria-label="Open pro1" tabindex="-1"
                        class="btn-hover mt-1 px-5 py-3 mx-auto d-block" data-toggle='modal' data-target='#pspa37'
                        id="modal37">
                        <p hidden>pro</p>
                        <em></em>
                    </a>
                    <span>
                        <a href="#" role="button" class="global_button   text-left " data-bs-toggle="modal"
                            data-bs-target="#myModalAngularJs">
                            <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png"
                                    alt="Angular JS Developer" /></div>
                            MORE DETAILS
                        </a>
                    </span>
                </div>
            </div>
            <div class="row mt-5 mb-3">
                <div class="col-12 col-sm-12 col-md-3 col-lg-4 col-xl-4">
                    <div class="career-bottom">
                        <div>
                            <p class="text-blue global_section_content career_subsection">Full Time</p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                    <div class="career-bottom">
                        <div>
                            <p class="text-blue global_section_content career_subsection">
                                <i class="fa fa-map-marker-alt"></i>
                                Location : Waterbury, CT 06702
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid ">
        <div class="container py-3 pt-5">
            <div class="row mt-2">
                <div class="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7">
                    <div class="job-heading">
                        <div class="mit-red  text-black mb-4">Java/API/Service Developer </div>
                        <p class="global_section_content">
                            Maganti IT Resources LLC is seeking one professional for Fulltime employment (40 hours/week)
                            for a Java/API/Service Developer position at Waterbury, CT 06702.</p>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 d-flex align-items-center Digital">
                    <a href="#" role="button" aria-label="Open pro2" tabindex="-1"
                        class="btn-hover mt-1 px-5 py-3 mx-auto d-block" data-toggle='modal' data-target='#pspa37'
                        id="modal37">
                        <p hidden>pro</p>
                        <em></em>
                    </a>
                    <span>
                        <a href="#" class="global_button   text-left " data-bs-toggle="modal"
                            data-bs-target="#myModalServiceDev">
                            <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png"
                                    alt="Service Developer" /></div>
                            MORE DETAILS
                        </a>
                    </span>
                </div>
            </div>
            <div class="row mt-5 mb-3">
                <div class="col-12 col-sm-12 col-md-3 col-lg-4 col-xl-4">
                    <div class="career-bottom">
                        <div>
                            <p class="text-blue global_section_content career_subsection">Full Time</p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                    <div class="career-bottom">
                        <div>
                            <p class="text-blue global_section_content career_subsection">
                                <i class="fa fa-map-marker-alt"></i>
                                Location : Waterbury, CT 06702
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--======Sr. Technical ConsultantJob Start ======-->
    <div class="container-fluid career-bg">
        <div class="container py-3 pt-5">
            <div class="row mt-2">
                <div class="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7">
                    <div class="job-heading">
                        <div class="mit-red  text-black mb-4">Sr. Technical Consultant</div>
                        <p class="global_section_content">
                            Maganti IT Resources LLC is seeking one professional for the full-time position of a Sr.
                            Technical Consultant(SharePoint).</p>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 d-flex align-items-center Digital">
                    <a href="#" role="button" aria-label="Open pro5" tabindex="-1" ari
                        class="btn-hover mt-1 px-5 py-3 mx-auto d-block" data-toggle='modal' data-target='#pspa37'
                        id="modal37">
                        <p hidden>pro</p>
                        <em></em>
                    </a>
                    <span>
                        <a href="#" role="button" class="global_button   text-left " data-bs-toggle="modal"
                            data-bs-target="#myModal28">
                            <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png"
                                    alt="Sr Technical Consultant" /></div>
                            MORE DETAILS
                        </a>
                    </span>
                </div>
            </div>
            <div class="row mt-5 mb-3">
                <div class="col-12 col-sm-12 col-md-3 col-lg-4 col-xl-4">
                    <div class="career-bottom">
                        <div>
                            <p class="text-blue global_section_content career_subsection">Full Time</p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                    <div class="career-bottom">
                        <div>
                            <p class="text-blue global_section_content career_subsection">
                                <i class="fa fa-map-marker-alt"></i>
                                Location : Waterbury CT, USA
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal" id="myModalNet">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="career-modal global_sub_title  mx-5 ">.NET framework</div>
                </div>

                <div class="modal-body">
                    <div class='page-meta career_popupcontent'>
                        <div class='row'>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>Location:</span> &nbsp; Waterbury, CT 06702
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0  w-20'>
                                <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0 w-30'>
                                <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp; April 17, 2025
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>End Date:</span> &nbsp; May 02,2025
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="career_popupcontent">Maganti IT Resources LLC is seeking one professional for a full-time employment (40 hours a week) for the position of a .NET Programmer at a competitive salary. 
                    </div>
                    <div class="global_sub_title job-description mt-4"><b>Job duties include (but not limited to)</b>
                    </div>
                    <div class="career_popupcontent">
                        
                        <ul class="bullet-list">
                                <li>
                                  <strong>Analyze User and Business Requirements</strong>
                                  <ul class="innerListStyle">
                                    <li>Work with stakeholders to understand functional requirements.
                                    </li>
                                    <li>Translate requirements into technical specifications.</li>
                                  </ul>
                                </li>
                                <li>
                                    <strong>Maintain and Enhance Existing Applications</strong>
                                    <ul class="innerListStyle">
                                      <li>Debug and troubleshoot legacy .NET applications.</li>
                                      <li>Implement enhancements and optimize performance.</li>
                                    </ul>
                                  </li>  
                                  <li>
                                    <strong>Perform Code Reviews and Testing</strong>
                                    <ul class="innerListStyle">
                                      <li>Conduct peer reviews to ensure code quality and compliance with standards.</li>
                                      <li>Develop and execute unit and integration tests.</li>
                                    </ul>
                                  </li>  
                                  <li>
                                    <strong>Collaborate with Cross-Functional Teams</strong>
                                    <ul class="innerListStyle">
                                      <li>Work alongside UI/UX designers, QA testers, DBAs, and project managers.</li>
                                      <li>Participate in agile ceremonies like stand-ups, sprint planning, and retrospectives.</li>
                                    </ul>
                                  </li>  
                                  <li>
                                    <strong>Database Integration</strong>
                                    <ul class="innerListStyle">
                                      <li>Develop and optimize SQL queries and stored procedures.</li>
                                      <li>Integrate with databases such as SQL Server or Oracle.</li>
                                    </ul>
                                  </li>
                                  <li>
                                    <strong>Follow Development Best Practices</strong>
                                    <ul class="innerListStyle">
                                      <li>Adhere to secure coding practices and performance optimization.</li>
                                      <li>Use version control systems (e.g., Git, Azure DevOps).</li>
                                    </ul>
                                  </li>
                                  <li>
                                    <strong>Stay Updated with Emerging Technologies</strong>
                                    <ul class="innerListStyle">
                                      <li>Continuously learn and apply new tools, libraries, and frameworks relevant to .NET development.</li>
                                    </ul>
                                  </li>
                        </ul>
                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Education Required:</b></div>
                    <div class="career_popupcontent">
                        <ul class="bullet-list">
                            <li>  Master of Computer Science or a related field.</li>

                        </ul>
                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Send your resume to:</b></div>
                    <div class="career_popupcontent">  ATTN: HR, Maganti IT Resources, LLC, 21 State St, Waterbury, CT 06702</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!--======Sr. Technical Consultant  End ======-->
    <div class="modal" id="myModalBa">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="career-modal global_sub_title  mx-5 ">Business Analyst </div>
                </div>

                <div class="modal-body">
                    <div class='page-meta career_popupcontent'>
                        <div class='row'>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>Location:</span> &nbsp; 21 State St,
                                    Waterbury, CT 06702
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0  w-20'>
                                <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0 w-30'>
                                <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp; April 09, 2025
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>End Date:</span> &nbsp; April 24,2025
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="career_popupcontent">Maganti IT Resources LLC is seeking one professional for the
                        full-time position of a Business Analyst at a competitive salary for our Waterbury, CT office.
                    </div>
                    <div class="global_sub_title job-description mt-4"><b>Responsibilities</b></div>
                    <div class="career_popupcontent">
                        <ul class="bullet-list">
                            Job duties:

                            <li> Conduct organizational studies and evaluations, design systems and procedures, conduct
                                work simplification, measurement studies.</li>
                            <li>Prepare operations and procedures manuals to assist management in operating more
                                efficiently and effectively.</li>
                            <li>Identify and analyze
                                data gathered and develop solutions or alternative methods of the proceeding.</li>
                            <li> Determine
                                techniques through requirements gathering for problem-solving and deliver the business
                                objectives.</li>
                            <li> Work collaboratively with business and technology partners to implement
                                solutions and overall strategies that address complex business needs and opportunities.
                            </li>
                            <li> Create and manage the basic tools (i.e. process maps / flows, rules matrices, mockups,
                                etc.)
                                and advanced business analysis tools and techniques (i.e. data matrices, contextual
                                level
                                data diagrams, system interface diagrams, etc. Documentation (Epics, Features, Use
                                Stories,
                                test strategy & execution (test plans, cases, reporting).</li>
                            <li> Perform in-depth analysis of
                                existing system. Evaluate different data sources and existing API structure for systems.
                                Evaluate details, and develop detailed understanding of business requirements, impacts
                                and
                                potential issues across various processes, teams, and brands.</li>
                            <li> Work with technical architects
                                to finalize technical workflows. Evaluate the existing state of the system and perform
                                requirement elicitation, Gap analysis with stakeholders.</li>

                        </ul>
                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Skills and Qualification</b></div>
                    <div class="career_popupcontent">
                        <ul class="bullet-list">
                            <li> The minimum educational qualification for this position is Bachelor of Computer Science
                                or related field.</li>

                        </ul>
                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
                    <div class="career_popupcontent"> Maganti IT Resources, LLC, 21 State St, Waterbury, CT 06702</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="modal" id="myModalSd">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="career-modal  global_sub_title mx-5 "> Software Developer</div>
                </div>
                <div class="modal-body">
                    <div class='page-meta career_popupcontent'>
                        <div class='row'>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>Location:</span> &nbsp; Waterbury - USA
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-2 py-0  w-20'>
                                <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0 w-30'>
                                <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp; April 10,2025
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>End Date:</span> &nbsp; May 12,2025</div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="career_popupcontent">Maganti IT Resources LLC is seeking one professional for a fulltime
                        employment (40 hours/week) for a Software Developer position at Waterbury, CT.</div>
                    <div class="global_sub_title job-description mt-4"><b>Job duties</b></div>
                    <div class="career_popupcontent">
                        <ul class="bullet-list">
                        
                            <li> Coordinate with Business and IT Stakeholders on project status, proposals and technical
                                implementation on software system design and support.</li>
                            <li> Troubleshoot problems and develop
                                permanent resolutions.</li>
                            <li>  Fix issues in existing applications within the agreed timelines and
                                targets as defined in service levels.</li>
                            <li>Analyze information to determine, recommend, and plan
                                installation of a new system or modification of an existing system.</li>
                            
                        </ul>
                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Education Required</b></div>
                    <div class="career_popupcontent"> Master of Information Technology or Related Field.</div>
                    <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
                    <div class="career_popupcontent">Maganti IT Resources, LLC, 21 State St, Waterbury, CT 06702</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div> -->
    
    <div class="modal" id="myModalSoftEngg">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="career-modal  global_sub_title mx-5 ">Software Engineer </div>
                </div>
                <div class="modal-body">
                    <div class='page-meta career_popupcontent'>
                        <div class='row'>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>Location:</span> &nbsp; Waterbury - USA
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-2 py-0  w-20'>
                                <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0 w-30'>
                                <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp; May 13, 2025
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>End Date:</span> &nbsp; May 29, 2025</div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="career_popupcontent">Maganti IT Resources, LLC is looking for a full-time Software Engineer.</div>
                    <div class="global_sub_title job-description mt-4"><b>Job duties(but not limited to)</b></div>
                    <div class="career_popupcontent">
                        <ul class="bullet-list">
                            <li>Analyze business requirements, processes, data, and system integration points to determine/recommend appropriate technology solutions.  </li>
                            <li>Analyze information to determine, recommend, and plan the installation of a new system or modification of an existing system.
                            </li>
                            <li>Address data delivery needs of the clients by designing Restful API to extract information from the MongoDB database.  </li>
                            <li>Collaborate with peer engineers to execute Unit Tests and conduct detailed code reviews of the software. </li>
                            <li>Successfully collaborate with clients to elicit and gather software requirements.  </li>
                            <li>Prepare reports or correspondence concerning project specifications or status. </li>
                            <li>Confer with project managers to obtain information on limitations or capabilities for data processing projects. </li>
                            <li>Create design specifications for high availability and highly scalable applications which will be used by both internal and external customers. </li>
                            <li>Design, Code, Test, Document, and Deploy global applications based on system and user requirements. </li>
                            <li>Generate technical documentation as well as a unit and functional tests. </li>
                            <li>Work with clients and Business Analysts to determine software requirements and system impacts.</li>
                            <li>Work closely with the global development team, other senior Solution Architects, and executives within the Online Product Engineering group to plan ongoing feature development, product maintenance, and management of development teams. </li>
                            <li>Work closely with the Enterprise Architects and the development teams through all phases of the SDLC. </li>
                            <li>Investigate new technologies and techniques and research ongoing industry developments. </li>
                            <li>Initiate major changes in architecture and software development techniques/processes. </li>
                           
                        </ul>
                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Education Required</b></div>
                    <div class="career_popupcontent">  Master of Computer Science or related field.</div>
                    <div class="global_sub_title job-description  mt-4"><b>Send your Resume to</b></div>
                    <div class="career_popupcontent">Maganti IT Resources, LLC, 21 State St, Waterbury, CT 06702</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!--====== Digital Marketing Specialist start ======-->
    <div class="modal" id="myModal13">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="career-modal  mx-5 ">Digital Marketing Specialist</div>
                </div>
                <div class="modal-body">
                    <div class='page-meta career_popupcontent'>
                        <div class='row'>
                            <div class='col-xs-12 col-sm-4 py-0'>
                                <div><span class='c-orange job-career-title'>Location:</span> &nbsp; Vijayawada- INDIA
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-4 py-0  w-20'>
                                <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                            </div>
                            <div class='col-xs-12 col-sm-4 py-0 w-30'>
                                <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp; June 05, 2024
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="career_popupcontent">Maganti IT Resources LLC is seeking one professional for the
                        full-time position of a Digital Marketing Specialist.</div>
                    <div class="global_sub_title job-description mt-4"><b>Responsibilities</b></div>
                    <div class="career_popupcontent">
                        <ul class="bullet-list">
                            <li>Develop and execute comprehensive digital marketing strategies aligned with business
                                objectives.</li>
                            <li>Manage and optimize digital advertising campaigns across platforms such as Google Ads,
                                Facebook Ads, LinkedIn Ads, etc.</li>
                            <li>Create and implement SEO strategies to improve organic search rankings and drive website
                                traffic.</li>
                            <li>Plan and execute email marketing campaigns, including segmentation, A/B testing, and
                                performance analysis.</li>
                            <li>Manage social media channels and develop content calendars for consistent brand
                                messaging and engagement.</li>
                            <li>Analyze campaign performance metrics, track KPIs, and generate reports to evaluate ROI
                                and identify optimization opportunities.</li>
                            <li>Collaborate with internal teams (e.g., content creators, designers, developers) to
                                produce compelling digital assets and landing pages.</li>
                            <li>Stay updated with industry trends, best practices, and emerging technologies to
                                recommend innovative digital marketing strategies.</li>
                        </ul>
                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Skills and Qualification</b></div>
                    <div class="career_popupcontent">
                        <ul class="bullet-list">
                            <li>Proficiency in digital marketing tools and platforms such as Google Analytics, Google
                                Ads, Facebook Business Manager, SEMrush, etc.</li>
                            <li>Strong understanding of SEO principles, keyword research, and content optimization
                                strategies.</li>
                            <li>Experience with email marketing platforms (e.g., Mailchimp, HubSpot) and marketing
                                automation.</li>
                            <li>Excellent analytical skills with the ability to interpret data and generate actionable
                                insights.</li>
                        </ul>
                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
                    <div class="career_popupcontent">krishnan&#64;mitresources.com</div>
                    <div class="career_popupcontent">sruthik&#64;mitresources.com</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!--====== Digital Marketing Specialist End ======-->
    <!--======>Sr. .NET Developer Job start ======-->
    <div class="modal" id="myModal24">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="career-modal  mx-5 ">AEM Front End Developer</div>
                </div>
                <div class="modal-body">
                    <div class='page-meta career_popupcontent'>
                        <div class='row'>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>Location:</span> &nbsp; Waterbury - USA
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-2 py-0  w-20'>
                                <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0 w-30'>
                                <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp; July 24,2024
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>End Date:</span> &nbsp; August 08,2024
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="career_popupcontent">Maganti IT Resources LLC is seeking one professional for the
                        full-time position of an AEM Front End Developer.</div>
                    <div class="global_sub_title job-description mt-4"><b>Job duties</b></div>
                    <div class="career_popupcontent">
                        <ul class="bullet-list">
                            <li>Develop and maintain marketing pages using AEM 6.2 using front-end languages like
                                <b>HTML, CSS, SCSS, and JavaScript, jQuery</b>.
                            </li>
                            <li>Optimize front end for maximum <b>page performance</b> across <b>multiple devices</b>
                                and browsers; work with Development Leads to address customer requirements; provide
                                requirements analysis for scope and time estimates.</li>
                            <li>Use variants feature in content fragments to add styles to components in authoring mode.
                            </li>
                            <li>Provide production for <b>AEM</b> components and give code fixes for UI-related issues.
                            </li>
                            <li>Provide and implement permanent fixes for production issues.</li>
                            <li>Work on customizing the bootstrap classes using <b>CSS</b> preprocessors like
                                <b>SCSS</b>.
                            </li>
                            <li>Provide technical support for queries related to the application in-scope.</li>
                            <li>Coordinate with QA test team for <b>regression</b> and <b>functional</b> testing for the
                                components/code developed.</li>
                        </ul>
                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Education Required</b></div>
                    <div class="career_popupcontent"> The minimum educational qualification for this position is
                        bachelor’s degree in Computer Science or related field.
                    </div>

                    <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
                    <div class="career_popupcontent">hr&#64;mitresource.com</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!--======>Sr. .NET Developer End ======-->
    <!--======Front End Developer Job start ======-->
    <div class="modal" id="myModal20">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="career-modal  mx-5 ">Front End Developer</div>
                </div>
                <div class="modal-body">
                    <div class='page-meta career_popupcontent'>
                        <div class='row'>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>Location:</span> &nbsp; Waterbury - USA
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-2 py-0  w-20'>
                                <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0 w-30'>
                                <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp; May 03,2024 </div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>End Date:</span> &nbsp; May 20,2024</div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="career_popupcontent">Maganti IT Resources LLC is seeking one professional for the
                        full-time position of a Front End Developer.</div>
                    <div class="global_sub_title job-description mt-4"><b>Job duties</b></div>
                    <div class="career_popupcontent">
                        <ul class="bullet-list">
                            <li>Collaborate with design teams to translate UI/UX design wireframes into actual code</li>
                            <li>Develop responsive web-based user interfaces using HTML, CSS, and JavaScript</li>
                            <li>Implement interactive features and functionalities using front-end frameworks like
                                React, Angular, or Vue.js</li>
                            <li>Optimize web applications for maximum speed and scalability</li>
                            <li>Ensure cross-browser compatibility and responsiveness of web applications</li>
                            <li>Conduct thorough testing to identify and fix UI/UX issues</li>
                            <li>Collaborate with back-end developers to integrate front-end components with server-side
                                logic</li>
                            <li>Stay updated on emerging front-end technologies and best practices</li>
                            <li>Maintain code integrity and organization through proper version control and
                                documentation practices</li>
                            <li>Participate in code reviews and provide constructive feedback to peers.</li>
                        </ul>
                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Education Required</b></div>
                    <div class="career_popupcontent">Bachelor Computer Science or related field.</div>

                    <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
                    <div class="career_popupcontent">hr&#64;mitresource.com</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!--======Front End Developer End ======-->
    <!--======Sr. UI Engineer Job start ======-->
    <div class="modal" id="myModal18">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="career-modal  mx-5 ">Sr. UI Engineer</div>
                </div>
                <div class="modal-body">
                    <div class='page-meta career_popupcontent'>
                        <div class='row'>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>Location:</span> &nbsp; Waterbury - USA
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-2 py-0  w-20'>
                                <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0 w-30'>
                                <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp; April 16,2024
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>End Date:</span> &nbsp; May 1,2024</div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="career_popupcontent">Maganti IT Resources, LLC is looking for 1 full-time (40 hours per
                        week) Sr. UI Engineer.</div>
                    <div class="global_sub_title job-description mt-4"><b>Job duties</b></div>
                    <div class="career_popupcontent">
                        <ul class="bullet-list">
                            <li>Lead the design and development of user interfaces for web applications, ensuring
                                high-quality, responsive, and intuitive user experiences.</li>
                            <li>Collaborate with product managers, designers, and other stakeholders to gather
                                requirements and translate them into technical specifications and UI designs.</li>
                            <li>Architect, implement, and maintain front-end codebases using modern web technologies
                                such as HTML5, CSS3, JavaScript, and frameworks/libraries like React.js, Angular, or
                                Vue.js.</li>
                            <li>Develop reusable UI components and libraries to streamline development processes and
                                promote code maintainability and scalability.</li>
                            <li>Implement responsive design principles and cross-browser compatibility to ensure
                                consistent performance and accessibility across various devices and platforms.</li>
                            <li>Optimize web applications for performance and speed, leveraging techniques such as code
                                splitting, lazy loading, and caching to enhance user experience.</li>
                            <li>Conduct code reviews and provide constructive feedback to junior engineers to ensure
                                code quality, consistency, and adherence to best practices and design patterns.</li>
                            <li>Stay updated with emerging trends and technologies in front-end development, evaluating
                                and integrating new tools and frameworks to enhance development workflows and
                                capabilities.</li>
                            <li>Collaborate with back-end developers to integrate front-end components with server-side
                                logic and data sources, ensuring seamless communication and data exchange between the
                                client and server.</li>
                            <li>Implement and maintain automated testing processes for front-end code, including unit
                                tests, integration tests, and end-to-end tests, using tools like Jest, Mocha, or
                                Selenium.</li>
                            <li>Work closely with UX/UI designers to iterate on design prototypes and wireframes,
                                providing technical insights and feasibility assessments to refine the user interface
                                design.</li>
                            <li>Provide technical leadership and mentorship to junior UI engineers, fostering a culture
                                of collaboration, continuous learning, and innovation within the front-end development
                                team.</li>
                            <li>Document technical designs, implementation details, and best practices to facilitate
                                knowledge sharing and onboarding of new team members.</li>
                            <li>Participate in Agile or Scrum methodologies for project planning, sprint execution, and
                                retrospective meetings, contributing to the continuous improvement of development
                                processes and workflows.</li>
                        </ul>
                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Education Required</b></div>
                    <div class="career_popupcontent">Bachelor Computer Science or related field.</div>
                    <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
                    <div class="career_popupcontent">hr&#64;mitresource.com</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!--======Sr. UI Engineer Job End ======-->
    <!--======Sr.Software Engineer start ======-->
    <div class="modal" id="myModal02">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="career-modal  mx-5 ">Sr.Software Engineer</div>
                </div>
                <div class="modal-body">
                    <div class='page-meta career_popupcontent'>
                        <div class='row'>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>Location:</span> &nbsp; Waterbury - USA
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-2 py-0  w-20'>
                                <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0 w-30'>
                                <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp; April 11,2024
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>End Date:</span> &nbsp; April 26,2024</div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="career_popupcontent">Maganti IT Resources, LLC is looking for 1 full-time (40 hours per
                        week) Sr. Software Engineer.</div>
                    <div class="global_sub_title job-description mt-4"><b>Job duties</b></div>
                    <div class="career_popupcontent">
                        <ul class="bullet-list">
                            <li>Analyze business requirements, processes, data, and system integration points to
                                determine/recommend appropriate technology solutions.</li>
                            <li>Analyze information to determine, recommend, and plan the installation of a new system
                                or modification of an existing system.</li>
                            <li>Address data delivery needs of the clients by designing Restful API to extract
                                information from the MongoDB database.</li>
                            <li>Collaborate with peer engineers to execute Unit Tests and conduct detailed code reviews
                                of the software.</li>
                            <li>Successfully collaborate with clients to elicit and gather software requirements.</li>
                            <li>Prepare reports or correspondence concerning project specifications or status.</li>
                            <li>Confer with project managers to obtain information on limitations or capabilities for
                                data processing projects.</li>
                            <li>Create design specifications for high availability and highly scalable applications
                                which will be used by both internal and external customers.</li>
                            <li>Design, Code, Test, Document, and Deploy global applications based on system and user
                                requirements.</li>
                            <li>Generate technical documentation as well as a unit and functional tests.</li>
                            <li>Work with clients and Business Analysts to determine software requirements and system
                                impacts.</li>
                            <li>Work closely with the global development team, other senior Solution Architects, and
                                executives within the Online Product Engineering group to plan ongoing feature
                                development, product maintenance, and management of development teams.</li>
                            <li>Work closely with the Enterprise Architects and the development teams through all phases
                                of the SDLC.</li>
                            <li>Investigate new technologies and techniques and research ongoing industry developments.
                            </li>
                            <li>Initiate major changes in architecture and software development techniques/processes.
                            </li>
                        </ul>
                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Education Required</b></div>
                    <div class="career_popupcontent">Bachelor of Computer Science or related field required.</div>
                    <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
                    <div class="career_popupcontent">Maganti IT Resources, LLC, 21 State St, Waterbury, CT 06702</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!--====== Sr.Software Engineer End ======-->
    <!--======>Sr. .NET Developer Job start ======-->
    <div class="modal" id="myModal22">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="career-modal  mx-5 ">Sr. .NET Developer</div>
                </div>
                <div class="modal-body">
                    <div class='page-meta career_popupcontent'>
                        <div class='row'>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>Location:</span> &nbsp; Waterbury - USA
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-2 py-0  w-20'>
                                <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0 w-30'>
                                <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp; May 29,2024 </div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>End Date:</span> &nbsp; June 13,2024</div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="career_popupcontent">Maganti IT Resources LLC is seeking one professional for a
                        full-time employment (40 hours a week) for the position of Sr. Net Developer.</div>
                    <div class="global_sub_title job-description mt-4"><b>Job duties</b></div>
                    <div class="career_popupcontent">
                        <ul class="bullet-list">
                            <li>Design and build Eligibility and claim functionality of the application from scratch.
                            </li>
                            <li>Architect, design, and develop high-quality, scalable, and secure .NET applications to
                                support DMV operations.</li>
                            <li>Work on major functionality of the application.</li>
                            <li>Maintain session values for key objects of the application, follow SOLID principles and
                                design the application.</li>
                            <li> Develop and execute unit tests, integration tests, and debugging procedures to ensure
                                software quality and reliability.</li>
                            <li>Create Models, Views, and Controllers for the application; Provide ongoing maintenance,
                                support, and enhancements for existing applications to ensure optimal performance and
                                reliability.</li>
                            <li>Understand legacy applications build on Classic ASPX, the flow of code, and stored
                                procedures used in the application.</li>
                            <li>Rewrite the legacy application into .NET CORE MVC6 using Bootstrap UI for responsive
                                pages.</li>
                            <li>Use different available Bootstrap classes to design more responsive pages that fit all
                                screen sizes available.</li>
                            <li>Convert data from the database into JSON format files and retrieve useful information
                                using AJAX calls to render the response in UI.</li>
                            <li>Develop all the UI pages using extensive markup and scripting languages (HTML,
                                JavaScript, and CSS).</li>
                            <li>Develop AJAX based web UI framework by utilizing the JQUERY library.</li>
                            <li>Educate in device-neutral design incorporating responsive techniques employing the use
                                of CSS3 and JavaScript.</li>
                            <li>Utilize knowledge in HTML5 and CSS3 for a responsive design for site appearance and
                                functionality across all major devices and browsers.</li>
                            <li>Write a clean code to retrieve data for Look-up available in the application.</li>
                            <li>Write LINQ queries to get the data from the Manager class and bind it to Views.</li>
                            <li>Design UI layout using HTML, CSS, JS, and Bootstrap.</li>
                        </ul>
                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Education Required</b></div>
                    <div class="career_popupcontent"> Bachelor of Computer Science or a related field.</div>

                    <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
                    <div class="career_popupcontent">hr&#64;mitresource.com</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!--======>Sr. .NET Developer End ======-->
    <!--======>Sr. .NET Developer Job start ======-->
    <div class="modal" id="myModal21">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="career-modal  mx-5 ">Sr. .NET Developer</div>
                </div>
                <div class="modal-body">
                    <div class='page-meta career_popupcontent'>
                        <div class='row'>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>Location:</span> &nbsp; Waterbury - USA
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-2 py-0  w-20'>
                                <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0 w-30'>
                                <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp; May 22,2024 </div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>End Date:</span> &nbsp; June 07,2024</div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="career_popupcontent">Maganti IT Resources LLC is seeking one professional for a
                        full-time employment (40 hours a week) for the position of Sr. Net Developer.</div>
                    <div class="global_sub_title job-description mt-4"><b>Job duties</b></div>
                    <div class="career_popupcontent">
                        <ul class="bullet-list">
                            <li>Design and build Eligibility and claim functionality of the application from scratch.
                            </li>
                            <li>Architect, design, and develop high-quality, scalable, and secure .NET applications to
                                support DMV operations.</li>
                            <li>Work on major functionality of the application.</li>
                            <li>Maintain session values for key objects of the application, follow SOLID principles and
                                design the application.</li>
                            <li>Develop and execute unit tests, integration tests, and debugging procedures to ensure
                                software quality and reliability.</li>
                            <li>Create Models, Views, and Controllers for the application.</li>
                            <li>Provide ongoing maintenance, support, and enhancements for existing applications to
                                ensure optimal performance and reliability.</li>
                            <li>Understand legacy applications built on Classic ASPX, the flow of code, and stored
                                procedures used in the application.</li>
                            <li>Rewrite the legacy application into .NET CORE MVC6 using Bootstrap UI for responsive
                                pages.</li>
                            <li>Use different available Bootstrap classes to design more responsive pages that fit all
                                screen sizes available.</li>
                            <li>Convert data from the database into JSON format files and retrieve useful information
                                using AJAX calls to render the response in UI.</li>
                            <li>Develop all the UI pages using extensive markup and scripting languages (HTML,
                                JavaScript, and CSS).</li>
                            <li>Develop AJAX-based web UI framework by utilizing the jQuery library.</li>
                            <li>Educate in device-neutral design incorporating responsive techniques employing the use
                                of CSS3 and JavaScript.</li>
                            <li>Utilize knowledge in HTML5 and CSS3 for a responsive design for site appearance and
                                functionality across all major devices and browsers.</li>
                            <li>Write clean code to retrieve data for look-ups available in the application.</li>
                            <li>Write LINQ queries to get the data from the Manager class and bind it to Views.</li>
                            <li>Design UI layout using HTML, CSS, JS, and Bootstrap.</li>
                            <li>Work on AJAX calls to retrieve data in the form of a Data table.</li>
                            <li>Work with the BA and QA team to understand the business layer and develop the
                                application accordingly.</li>
                            <li>Help the QA team in testing and code reviews.</li>
                        </ul>
                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Education Required</b></div>
                    <div class="career_popupcontent">Bachelor of Computer Science or a related field.</div>

                    <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
                    <div class="career_popupcontent">hr&#64;mitresource.com</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!--======>Sr. .NET Developer End ======-->
    <!--======>Sr. .NET Developer Job start ======-->
    <div class="modal" id="myModal23">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="career-modal  mx-5 ">AEM Business Analyst</div>
                </div>
                <div class="modal-body">
                    <div class='page-meta career_popupcontent'>
                        <div class='row'>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>Location:</span> &nbsp; Waterbury - USA
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-2 py-0  w-20'>
                                <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0 w-30'>
                                <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp; July 03,2024
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>End Date:</span> &nbsp; July 19,2024</div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="career_popupcontent">Maganti IT Resources, LLC is looking for an AEM Business Analyst on
                        a full-time basis at Waterbury, CT, USA.</div>
                    <div class="global_sub_title job-description mt-4"><b>Job duties</b></div>
                    <div class="career_popupcontent">
                        Independently work with business partners and initiative owners to understand the end user’s
                        needs and pain points to define the requirements in agile stories for development. Support and
                        drive feasibility of AEM solutions to define technical solutions for customer problems. Help the
                        Product Owner and the agile team to clearly define and sequence the work to implement short-term
                        and long-term solutions to Information technology needs (e.g. MVP-minimum viable product and
                        beyond, go to market strategy, release schedules). Flex to support experience design related
                        work (e.g., customer interviews, design thinking workshops, empathy mapping). Monitor usage and
                        collect feedback on functionality and experiences developed to ensure it meets the end user’s
                        needs. Proactively share insights and progress to promote a customer-centric culture and connect
                        the dots across experiences to inform the broader organization. Collaborate across agile teams
                        within the Customer Investment Journey (Individuals, Brokers) in biweekly scrum planning
                        sessions to conduct scrubbing, demos, retrospective meetings, and daily stand ups. Test the
                        Application during version upgrade and new service pack installation, with defined test plans.
                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Education Required</b></div>
                    <div class="career_popupcontent"> Bachelor of Technology or related field required.</div>

                    <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
                    <div class="career_popupcontent">hr&#64;mitresource.com</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!--======>Sr. .NET Developer End ======-->
    <!--======Software Engineer Job start ======-->
    <div class="modal" id="myModal05">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="career-modal  mx-5 ">Business Analyst</div>
                </div>
                <div class="modal-body">
                    <div class='page-meta career_popupcontent'>
                        <div class='row'>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>Location:</span> &nbsp; Waterbury - USA
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-2 py-0  w-20'>
                                <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0 w-30'>
                                <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp; October 07,2024
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>End Date:</span> &nbsp; October 23,2024
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="career_popupcontent">Maganti IT Resources LLC is seeking one professional for the
                        full-time position of a Business Analyst.</div>
                    <div class="global_sub_title job-description mt-4"><b>Job duties</b></div>
                    <div class="career_popupcontent">
                        Conduct organizational studies and evaluations, design systems and procedures, conduct work
                        simplification, measurement studies; prepare operations and procedures manuals to assist
                        management in operating more efficiently and effectively; identify and analyze data gathered and
                        develop solutions or alternative methods of the proceeding; determine techniques through
                        requirements gathering for problem-solving and deliver the business objectives. Work
                        collaboratively with business and technology partners to implement solutions and overall
                        strategies that address complex business needs and opportunities. Create and manage the basic
                        tools (i.e. process maps / flows, rules matrices, mockups, etc.) and advanced business analysis
                        tools and techniques (i.e. data matrices, contextual level data diagrams, system interface
                        diagrams, etc. Documentation (Epics, Features, Use Stories, test strategy & execution (test
                        plans, cases, reporting). Perform in-depth analysis of existing system. Evaluate different data
                        sources and existing API structure for systems. Evaluate details, and develop detailed
                        understanding of business requirements, impacts and potential issues across various processes,
                        teams, and brands. Work with technical architects to finalize technical workflows. Evaluate the
                        existing state of the system and perform requirement elicitation, Gap analysis with
                        stakeholders.

                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Education Required</b></div>
                    <div class="career_popupcontent">The minimum educational qualification for this position is Bachelor
                        of Computer Science or related field.
                    </div>

                    <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
                    <div class="career_popupcontent">hr&#64;mitresource.com</div>
                </div>

                <div class="modal-footer">
                    <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!--======Software Engineer Job End ======-->
    <!--======Software Engineer Job start ======-->
    <div class="modal" id="myModal26">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="career-modal mx-5 ">Business Analyst</div>
                </div>
                <div class="modal-body">
                    <div class='page-meta career_popupcontent'>
                        <div class='row'>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>Location:</span> &nbsp; Waterbury - USA
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-2 py-0  w-20'>
                                <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0 w-30'>
                                <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp; October 07,2024
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>End Date:</span> &nbsp; October 23,2024
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="career_popupcontent">Maganti IT Resources LLC is seeking one professional for the
                        full-time position of a Business Analyst.</div>
                    <div class="global_sub_title job-description mt-4"><b>Job duties</b></div>
                    <div class="career_popupcontent">
                        Conduct organizational studies and evaluations, design systems and procedures, conduct work
                        simplification, measurement studies; prepare operations and procedures manuals to assist
                        management in operating more efficiently and effectively; identify and analyze data gathered and
                        develop solutions or alternative methods of the proceeding; determine techniques through
                        requirements gathering for problem-solving and deliver the business objectives. Work
                        collaboratively with business and technology partners to implement solutions and overall
                        strategies that address complex business needs and opportunities. Create and manage the basic
                        tools (i.e. process maps / flows, rules matrices, mockups, etc.) and advanced business analysis
                        tools and techniques (i.e. data matrices, contextual level data diagrams, system interface
                        diagrams, etc.) Documentation (Epics, Features, Use Stories, test strategy) & execution (test
                        plans, cases, reporting). Perform in-depth analysis of existing system. Evaluate different data
                        sources and existing API structure for systems. Evaluate details, and develop detailed
                        understanding of business requirements, impacts and potential issues across various processes,
                        teams, and brands. Work with technical architects to finalize technical workflows. Evaluate the
                        existing state of the system and perform requirement elicitation, Gap analysis with
                        stakeholders.

                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Education Required</b></div>
                    <div class="career_popupcontent">The minimum educational qualification for this position is Bachelor
                        of Computer Science or related field.
                    </div>

                    <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
                    <div class="career_popupcontent">hr&#64;mitresource.com</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!--======Software Engineer Job End ======-->
    <!--======Software Engineer Job start ======-->
    <div class="modal" id="myModal26">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="career-modal  mx-5 ">Business Analyst</div>
                </div>
                <div class="modal-body">
                    <div class='page-meta career_popupcontent'>
                        <div class='row'>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>Location:</span> &nbsp; Waterbury - USA
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-2 py-0  w-20'>
                                <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0 w-30'>
                                <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp; January 26,2024
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>End Date:</span> &nbsp; &nbsp; February
                                    12,2024</div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="career_popupcontent">Maganti IT Resources LLC is seeking one professional for the
                        full-time position of a Business Analyst.</div>
                    <div class="global_sub_title job-description mt-4"><b>Job duties</b></div>
                    <div class="career_popupcontent">
                        Conduct organizational studies and evaluations, design systems and procedures, conduct work
                        simplification, measurement studies; prepare operations and procedures manuals to assist
                        management in operating more efficiently and effectively; identify and analyze data gathered and
                        develop solutions or alternative methods of the proceeding; determine techniques through
                        requirements gathering for problem-solving and deliver the business objectives.
                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Education Required</b></div>
                    <div class="career_popupcontent">The minimum educational qualification for this position is Master
                        of Business Administration or related field.</div>
                    <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
                    <div class="career_popupcontent">hr&#64;mitresource.com</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!--======Software Engineer Job End ======-->
   
    <!-- tester -->
    <div class="modal" id="myModalTester">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="career-modal global_sub_title mx-5 "> Web QA/BA Automation Tester</div>
                </div>
                <div class="modal-body">
                    <div class='page-meta career_popupcontent'>
                        <div class='row'>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>Location:</span> &nbsp; Waterbury, CT 06702
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-2 py-0  w-20'>
                                <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0 w-30'>
                                <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp; January 08, 2025
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>End Date:</span> &nbsp; &nbsp; January
                                    31, 2025</div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="career_popupcontent">Maganti IT Resources LLC is seeking one professional for a Web
                        QA/BA Automation Tester.</div>
                    <div class="global_sub_title job-description mt-4"><b>Job duties</b></div>
                    <div class="career_popupcontent">
                        <ul class="bullet-list">
                            <li> 5+ years of experience as a Manual and Automation Test Engineer.</li>
                            <li> Experience in Financial domain and working knowledge of Core Banking Application. </li>
                            <li> Experience in gathering and maintaining the business requirements for the new
                                enhancements and change requests.</li>
                            <li> Create and execute manual and automated tests based on feature enhancements for Web
                                application and Mobile app. </li>
                            <li>Experience in testing the Mobile App on iOS and Android platforms.</li>
                            <li> Well-versed with Mobile app testing tool like Browser Stack. </li>
                            <li>Experience in performing the function and regression testing for Web and Mobile App.
                            </li>
                            <li> Proficient in writing SQL queries to validate the end to end testing scenarios.</li>
                            <li> Experience in Web/Mobile App security and performance testing, would be a plus.</li>
                            <li> Create test plans/scenarios, prioritizing test cases and test coverage to meet release
                                deadlines.
                            </li>
                            <li> Experience designing the effective test cases that are easily maintainable, resilient,
                                performant and scalable.
                            </li>
                            <li> Development of automated test creation and execution using test automation tools. </li>
                            <li>Review and reproduce reported defects and document with clear replication steps. </li>
                            <li> Proficiency at identifying and analyzing the root cause of complex bugs.</li>
                            <li>Ability to communicate in oral and written form QA plans and issues.</li>
                            <li> Experience with test frameworks such as TestNG, JUnit, Jasmine etc.</li>
                            <li>Proficiency in one or more of the following technologies: Cypress with Typescript,
                                Selenium Web driver automation with Java, Python or other object-oriented languages.
                            </li>
                        </ul>
                    </div>

                    <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
                    <div class="career_popupcontent">ATTN: HR, Maganti IT Resources LLC, 21 State Street, Waterbury, CT
                        06702</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!-- tester -->
    <!-- AngulaJs -->
    <div class="modal" id="myModalAngularJs">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="career-modal global_sub_title mx-5 ">Angular JS Developer</div>
                </div>
                <div class="modal-body">
                    <div class='page-meta career_popupcontent'>
                        <div class='row'>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>Location:</span> &nbsp; Waterbury, CT 06702
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-2 py-0  w-20'>
                                <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0 w-30'>
                                <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp; January 08, 2025
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>End Date:</span> &nbsp; &nbsp; January 31,
                                    2025</div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="career_popupcontent">Maganti IT Resources LLC is seeking one professional for a Angular
                        JS Developer.</div>
                    <div class="global_sub_title job-description mt-4"><b>Responsibilities</b></div>
                    <div class="career_popupcontent">
                        <ul class="bullet-list">
                            <li> Delivering a complete front end application.</li>
                            <li> Build reusable code and libraries for future use.</li>
                            <li> Communicating with external web services.</li>
                            <li> Optimize the application for maximum speed and scalability.</li>
                            <li> Develop solutions that are functional in all major browsers and devices.</li>
                            <li> Collaborate with other team members and stakeholders, including the UX designer and
                                back-end developer.</li>
                            <li> Adhere to the team's standards and best coding practices.</li>
                            <li> Continuously work on self-improvement and look for avenues to improve the team.</li>

                        </ul>
                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Skills and Qualifications</b></div>
                    <div class="career_popupcontent">
                        <ul class="bullet-list">
                            <li> Professional communication skills.</li>
                            <li> Technical expertise is essential, design skills are appreciated.</li>
                            <li> Mastery of JavaScript, HTML 5, CSS 3, JavaScript, Bootstrap 4, Sass, Angular 6, and
                                TypeScript.</li>
                            <li> 6+ years of software development experience utilizing these UI Technologies with at
                                least 4 years’ experience working with Angular JS.</li>
                            <li> Deep knowledge of Angular best practices and commonly used modules based on extensive
                                work experience.</li>
                            <li> Experience with Single Page Application frameworks and libraries such as Angular,
                                jQuery, and Node.js.</li>
                            <li> Creating self-contained, reusable, and testable modules and components.</li>
                            <li> Working experience with Ionic and Cordova, and proficiency with building for mobile
                                (mobile web apps or hybrid apps).</li>
                            <li> Solid experience in responsive design concepts and building responsive web applications
                                using HTML, CSS, Bootstrap, Sass, and Less.</li>
                            <li> Thorough understanding of the responsibilities of the platform, database, API, caching
                                layer, proxies, and other web services used in the system.</li>
                            <li> Validating user actions on the client-side and providing responsive feedback.</li>
                            <li> Good understanding of asynchronous request handling, partial page updates, and Ajax.
                            </li>
                            <li> Experience with browser and device differences and limitations, and client-side
                                performance.</li>
                            <li> Experience in working in an Agile / Sprint based development environment.</li>
                            <li> Experience with the following is a plus: MDBootstrap, Node/NPM, Webpack, Visual Studio
                                Code, Git.</li>
                        </ul>
                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
                    <div class="career_popupcontent">ATTN: HR, Maganti IT Resources LLC, 21 State Street, Waterbury, CT
                        06702</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!-- AngularJs -->
   
    <!--======>AEM Developer Job start ======-->
    <div class="modal" id="myModalAem">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="career-modal global_sub_title  mx-5 ">AEM Developer</div>
                </div>
                <div class="modal-body">
                    <div class='page-meta career_popupcontent'>
                        <div class='row'>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>Location:</span> &nbsp; Waterbury - USA
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-2 py-0  w-20'>
                                <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0 w-30'>
                                <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp; February 24,2025
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>End Date:</span> &nbsp; March 12,2025</div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="career_popupcontent">Maganti IT Resources LLC is seeking one professional employment
                        with 40 hours a week for the position of AEM Developer at a competitive salary.</div>
                    <div class="global_sub_title job-description mt-4"><b>Job duties include (but not limited to)</b>
                    </div>
                    <div class="career_popupcontent">
                        <ul class="bullet-list">
                            <li>Responsible for Gathering Requirements from Business and providing Technical Solution
                                using AEM. </li>
                            <li>Fully involve in end to end delivery of Business requirements. </li>
                            <li> Setup and configure Authoring and Publishing environments, replication agents, CQ5
                                dispatcher to cache the landing page html and
                                serve as the static pages from Apache.</li>
                            <li>Develop custom workflows and workflow steps.</li>
                            <li> Register customized applications, created responsibilities, customized menus, attached
                                menus to
                                responsibilities and assigning to users.</li>
                            <li> Design and develop the organization of client libraries and created template components
                                using inheritance.</li>
                            <li> Develop Custom functionality in Search and Promote.</li>
                            <li> Involved in Sprint Planning, Development, Component creation, Testing & Delivery of
                                User stories in every 2 weeks sprint.</li>
                        </ul>
                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Educational requirement</b></div>
                    <div class="career_popupcontent"> The minimum educational qualification for this position is a
                        Bachelor of Computer Science or related field.</div>

                    <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
                    <div class="career_popupcontent">ATTN: HR, Maganti IT Resources, LLC, 21 State Street, Waterbury, CT
                        06702
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!--======>AEM Developer End ======-->
    <!-- Java/API/Service Developer -->
    <div class="modal" id="myModalServiceDev">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="career-modal global_sub_title mx-5 ">Java/API/Service Developer</div>
                </div>
                <div class="modal-body">
                    <div class='page-meta career_popupcontent'>
                        <div class='row'>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>Location:</span> &nbsp; Waterbury, CT 06702
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-2 py-0  w-20'>
                                <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0 w-30'>
                                <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp; January 08, 2025
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>End Date:</span> &nbsp; &nbsp; January 31,
                                    2025</div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="career_popupcontent">Maganti IT Resources LLC is seeking one professional for a
                        Java/API/Service Developer.</div>
                    <div class="global_sub_title job-description mt-4"><b>Responsibilities</b></div>
                    <div class="career_popupcontent">
                        Design and build RESTful web service APIs in Java that enable and support our member-facing web
                        applications and our partners.
                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Skills and Qualifications</b></div>
                    <div class="career_popupcontent">
                        <ul class="bullet-list">
                            <li> 6+ years of software development experience utilizing Java with at least 4 years’
                                experience working with REST Web Services.</li>
                            <li>Work collaboratively as part of an agile team to deliver solutions to business needs.
                            </li>
                            <li>Relentlessly pursue continuous improvement in our products and processes. </li>
                            <li>Build clean, documented, testable code using TDD, JUnit, Postman, and Swagger. </li>
                            <li>Build performant services, and be able to diagnose and resolve performance issues at all
                                layers of the system. </li>
                            <li>Must have deep knowledge and familiarity with web frameworks, such as Spring MVC or
                                Spring Boot. </li>
                            <li>Strong experience designing database tables and writing SQL queries in an RDBMS, such as
                                Oracle. </li>
                            <li>Comfortable working with standard dev tools like Eclipse, Git, Github, Jenkins, Maven,
                                and web app servers like WebSphere. </li>
                            <li>Strong foundational skills in Java and Object-Oriented Programming are required. </li>
                            <li>Build SSO and web service integrations with our partners using technologies such as SAML
                                and SOAP. </li>
                            <li>Must understand API security and have experience working with an API Gateway (such as
                                Tyk) for API authorization. </li>
                            <li>Provide technical assistance and guidance with designing complex features.  Conduct
                                design and code reviews. </li>
                            <li>Help the team meet their sprint deliverables by addressing any impediments in their
                                ways.</li>
                        </ul>
                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
                    <div class="career_popupcontent">ATTN: HR, Maganti IT Resources LLC, 21 State Street, Waterbury, CT
                        06702</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!-- Java/API/Service Developer -->
    <!--======Sr. . NET Developer job start ======-->
    <div class="modal" id="myModal07">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="career-modal mx-5 ">Sr. . NET Developer</div>
                </div>
                <div class="modal-body">
                    <div class='page-meta career_popupcontent'>
                        <div class='row'>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>Location:</span> &nbsp; Waterbury - USA
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-2 py-0  w-20'>
                                <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0 w-30'>
                                <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp; February 19,2024
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>End Date:</span> &nbsp; &nbsp; March
                                    05,2024</div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="career_popupcontent">Maganti IT Resources LLC is seeking one professional for part-time
                        employment (20 hours a week) for the position of Sr. Net Developer.</div>
                    <div class="global_sub_title job-description mt-4"><b>Job duties</b></div>
                    <div class="career_popupcontent">
                        Works closely with the team to resolve the Issues and take Owner ship of the same to ensure the
                        expected changes deployed to Production; Works closely with the team, Log Portal team, and
                        executives within the Logistics group to participate in Logistics Support work, managing various
                        project related support activities; Responsible for Email Blast, Vendor Registrations and
                        monitoring the Helpdesk requests; Worked throughout the Direct Connect Supplier request,
                        production live and monitoring after production live; Cross trained the European team and
                        offshore on Direct Connect processes; Participate in internal meetings with Business,
                        Development and with team as per the requirements; Technical Problem resolution &
                        Troubleshooting; Provides effective technical documentation. </div>

                    <div class="global_sub_title job-description  mt-4"><b>Technologies Platform Used</b></div>
                    <div class="career_popupcontent">ASP.Net, WCF, HTML, CSS, JavaScript, JSON, SOAP, REST, .Net
                        Framework, C#,VB.net, Web Services, Entity Framework, VB6, Classic ASP, Oracle and SQL Server,
                    </div>

                    <div class="global_sub_title job-description  mt-4"><b>Education Required</b></div>
                    <div class="career_popupcontent">Bachelor of Computer Science, Computer Engineering or a related
                        field.</div>

                    <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
                    <div class="career_popupcontent">hr&#64;mitresource.com</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!--======Sr. . NET Developer job End ======-->
    <!--======ERP Test Lead job start ======-->
    <div class="modal" id="myModal08">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="career-modal  mx-5 ">ERP Test Lead</div>
                </div>
                <div class="modal-body">
                    <div class='page-meta career_popupcontent'>
                        <div class='row'>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>Location:</span> &nbsp; Waterbury - USA
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-2 py-0  w-20'>
                                <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0 w-30'>
                                <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp; February 29,2024
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>End Date:</span> &nbsp; &nbsp; March
                                    14,2024</div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="career_popupcontent">Maganti IT Resources LLC is seeking 1 professional for a full-time
                        employment (40 hours a week) for the position of an ERP Test Lead.</div>
                    <div class="global_sub_title job-description mt-4"><b>Job duties</b></div>
                    <div class="career_popupcontent">
                        Responsible for the creation, organization, execution, and successful completion of projects,
                        acting as the primary point of contact for the client while managing client expectations and
                        satisfaction. Define testing strategy with business and IT. Establish a detailed test plan with
                        resource allocation. Develop the overall testing strategy and plan for the ERP implementation,
                        including testing scope, test scenarios, testing priorities, test cases, and resource
                        allocation. Provide management and oversight to client implementations including the development
                        of project plans and schedules, task management, resource planning, and communication of status
                        to stakeholders. Manage multiple concurrent projects, consultants, and clients, focusing on
                        adherence to scope, timeline, and budgets, ensuring project deliverables, deadlines, and client
                        expectations are met. Oversee and manage the documentation of business requirements, functional
                        requirements/specifications, interface requirements, data conversion requirements,
                        implementation requirements, use cases, scope changes, and design documentation. Identify and
                        analyze testing risks, ensuring mitigation plans are developed and implemented to minimize the
                        impact on system quality and project timelines. Facilitate project meetings and provide timely
                        status updates to management and relevant stakeholders on the project status, including a
                        budget, task completion, timeline, potential risks, and scope. Exercise risk and issue
                        management by identifying potential constraints based on activities and timeframes and lead an
                        effort to identify appropriate solutions to mitigate the impact on the project.
                        Assigns/delegates work assignments to project team members; motivate project staff and focuses
                        on quality, time, and scope. Monitors project deliverables and progress through continuous
                        communication with project members. </div>
                    <div class="global_sub_title job-description  mt-4"><b>Education Required</b></div>
                    <div class="career_popupcontent">Bachelor of Computer Science or a related field.</div>
                    <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
                    <div class="career_popupcontent">hr&#64;mitresource.com</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!--======ERP Test Lead job End ======-->
    <!--======System Data Analyst Job start ======-->
    <div class="modal" id="myModal09">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="career-modal  mx-5 ">System Data Analyst</div>
                </div>
                <div class="modal-body">
                    <div class='page-meta career_popupcontent'>
                        <div class='row'>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>Location:</span> &nbsp; Waterbury - USA
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-2 py-0  w-20'>
                                <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0 w-30'>
                                <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp; March 4,2024
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>End Date:</span> &nbsp; March 19,2024</div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="career_popupcontent">Maganti IT Resources LLC is seeking one professional for the
                        full-time position of a System Data Analyst.</div>
                    <div class="global_sub_title job-description mt-4"><b>Job duties</b></div>
                    <div class="career_popupcontent">
                        <ul class="bullet-list">
                            
                            <li>Data Collection and Integration: Gather data from various sources within the
                                organization and external sources, ensuring data integrity and accuracy.</li>
                            <li>Data Cleansing and Preprocessing: Cleanse, preprocess, and transform raw data to prepare
                                it for analysis, including handling missing values, outliers, and inconsistencies.</li>
                            <li>Database Management: Maintain and optimize databases, ensuring efficient data storage,
                                retrieval, and organization.</li>
                            <li>Data Analysis and Interpretation: Analyze data using statistical techniques and data
                                mining algorithms to identify trends, patterns, and insights relevant to business
                                objectives.</li>
                            <li>Dashboard Development: Design and develop interactive dashboards and reports to
                                visualize key performance indicators (KPIs) and metrics for stakeholders.</li>
                            <li>Data Modeling and Forecasting: Build predictive models and forecasting algorithms to
                                anticipate future trends and outcomes based on historical data.</li>
                            <li>Performance Monitoring: Monitor data systems and processes to identify performance
                                issues, bottlenecks, and opportunities for optimization.</li>
                            <li>Data Governance and Compliance: Ensure compliance with data governance policies,
                                regulations, and best practices to protect data privacy and security.</li>
                            <li>Stakeholder Communication: Communicate findings, recommendations, and insights to
                                stakeholders through presentations, reports, and data storytelling.</li>
                            <li>Continuous Improvement: Stay updated on emerging technologies, tools, and techniques in
                                data analysis and contribute to the continuous improvement of data processes and
                                systems.</li>
                        </ul>
                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Education Required</b></div>
                    <div class="career_popupcontent">Bachelor of Computer Science or related field.</div>

                    <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
                    <div class="career_popupcontent">hr&#64;mitresource.com</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!--======System Data Analyst Job End ======-->
    <!--======Quality Assurance Test Analyst Job start ======-->
    <div class="modal" id="myModal10">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="career-modal  mx-5 ">ERP Test Lead</div>
                </div>
                <div class="modal-body">
                    <div class='page-meta career_popupcontent'>
                        <div class='row'>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>Location:</span> &nbsp; Waterbury - USA
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-2 py-0  w-20'>
                                <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0 w-30'>
                                <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp; February 29,2024
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>End Date:</span> &nbsp; March 14,2024</div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="career_popupcontent">Maganti IT Resources LLC is seeking 1 professional for a full-time
                        employment (40 hours a week) for the position of an ERP Test Lead at a competitive salary.</div>
                    <div class="global_sub_title job-description mt-4"><b>Job duties</b></div>
                    <div class="career_popupcontent">
                        Responsible for the creation, organization, execution, and successful completion of projects,
                        acting as the primary point of contact for the client while managing client expectations and
                        satisfaction. Define testing strategy with business and IT. Establish a detailed test plan with
                        resource allocation. Develop the overall testing strategy and plan for the ERP implementation,
                        including testing scope, test scenarios, testing priorities, test cases, and resource
                        allocation. Provide management and oversight to client implementations including the development
                        of project plans and schedules, task management, resource planning, and communication of status
                        to stakeholders. Manage multiple concurrent projects, consultants, and clients, focusing on
                        adherence to scope, timeline, and budgets, ensuring project deliverables, deadlines, and client
                        expectations are met. Oversee and manage the documentation of business requirements, functional
                        requirements/specifications, interface requirements, data conversion requirements,
                        implementation requirements, use cases, scope changes, and design documentation. Identify and
                        analyze testing risks, ensuring mitigation plans are developed and implemented to minimize the
                        impact on system quality and project timelines. Facilitate project meetings and provide timely
                        status updates to management and relevant stakeholders on the project status, including a
                        budget, task completion, timeline, potential risks, and scope. Exercise risk and issue
                        management by identifying potential constraints based on activities and timeframes and lead an
                        effort to identify appropriate solutions to mitigate the impact on the project.
                        Assigns/delegates work assignments to project team members; motivate project staff and focuses
                        on quality, time, and scope. Monitors project deliverables and progress through continuous
                        communication with project members.

                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Education Required</b></div>
                    <div class="career_popupcontent">Bachelor of Computer Science or a related field.</div>
                    <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
                    <div class="career_popupcontent">hr&#64;mitresource.com</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!--======Quality Assurance Test Analyst Job End ======-->
    <!--======Quality Assurance Test Analyst Job start ======-->
    <div class="modal" id="myModal11">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="career-modal  mx-5 ">Quality Assurance Test Analyst</div>
                </div>
                <div class="modal-body">
                    <div class='page-meta career_popupcontent'>
                        <div class='row'>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>Location:</span> &nbsp; Waterbury - USA
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-2 py-0  w-20'>
                                <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0 w-30'>
                                <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp; March 25,2024
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>End Date:</span> &nbsp; April 05,2024</div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="career_popupcontent">Maganti IT Resources LLC is seeking one professional for the
                        full-time position of a Quality Assurance Test Analyst.</div>
                    <div class="global_sub_title job-description mt-4"><b>Job duties</b></div>
                    <div class="career_popupcontent">
                        <ul class="bullet-list">
                            <li>Develop and execute test plans, test cases, and test scripts to ensure software quality.
                            </li>
                            <li>Perform functional, regression, and integration testing on software applications.</li>
                            <li>Identify, isolate, and document software defects in a clear and concise manner.</li>
                            <li>Collaborate with cross-functional teams to ensure timely resolution of issues.</li>
                            <li>Participate in requirement analysis and review meetings to ensure test coverage.</li>
                            <li>Utilize automated testing tools and frameworks to streamline testing processes.</li>
                            <li>Maintain test documentation and contribute to the improvement of QA processes.</li>
                            <li>Conduct performance and scalability testing as required.</li>
                            <li>Provide accurate and timely status reports on testing progress and issues encountered.
                            </li>
                            <li>Stay updated with industry trends and best practices in software quality assurance.
                            </li>
                        </ul>
                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Education Required</b></div>
                    <div class="career_popupcontent">Bachelor of Computer Science or related field required.</div>

                    <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
                    <div class="career_popupcontent">hr&#64;mitresource.com</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!--======Quality Assurance Test Analyst Job End ======-->
    <!--====== Digital Marketing Specialist start ======-->
    <div class="modal" id="myModal12">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="career-modal  mx-5 ">Digital Marketing Specialist</div>
                </div>
                <div class="modal-body">
                    <div class='page-meta career_popupcontent'>
                        <div class='row'>
                            <div class='col-xs-12 col-sm-4 py-0'>
                                <div><span class='c-orange job-career-title'>Location:</span> &nbsp; Vijayawada- INDIA
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-4 py-0  w-20'>
                                <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                            </div>
                            <div class='col-xs-12 col-sm-4 py-0 w-30'>
                                <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp; April 16, 2024
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="career_popupcontent">Maganti IT Resources LLC is seeking one professional for the
                        full-time position of a Digital Marketing Specialist.</div>
                    <div class="global_sub_title job-description mt-4"><b>Responsibilities</b></div>
                    <div class="career_popupcontent">
                        <ul class="bullet-list">
                            <li>Develop and execute comprehensive digital marketing strategies aligned with business
                                objectives.</li>
                            <li>Manage and optimize digital advertising campaigns across platforms such as Google Ads,
                                Facebook Ads, LinkedIn Ads, etc.</li>
                            <li>Create and implement SEO strategies to improve organic search rankings and drive website
                                traffic.</li>
                            <li>Plan and execute email marketing campaigns, including segmentation, A/B testing, and
                                performance analysis.</li>
                            <li>Manage social media channels and develop content calendars for consistent brand
                                messaging and engagement.</li>
                            <li>Analyze campaign performance metrics, track KPIs, and generate reports to evaluate ROI
                                and identify optimization opportunities.</li>
                            <li>Collaborate with internal teams (e.g., content creators, designers, developers) to
                                produce compelling digital assets and landing pages.</li>
                            <li>Stay updated with industry trends, best practices, and emerging technologies to
                                recommend innovative digital marketing strategies.</li>
                        </ul>
                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Skills and Qualification</b></div>
                    <div class="career_popupcontent">
                        <ul class="bullet-list">
                            <li>Proficiency in digital marketing tools and platforms such as Google Analytics, Google
                                Ads, Facebook Business Manager, SEMrush, etc.</li>
                            <li>Strong understanding of SEO principles, keyword research, and content optimization
                                strategies.</li>
                            <li>Experience with email marketing platforms (e.g., Mailchimp, HubSpot) and marketing
                                automation.</li>
                            <li>Excellent analytical skills with the ability to interpret data and generate actionable
                                insights.</li>
                        </ul>
                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
                    <div class="career_popupcontent">krishnan&#64;mitresources.com</div>
                    <div class="career_popupcontent">sruthik&#64;mitresources.com</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!--====== Digital Marketing Specialist End ======-->
    <!--======Sr. Software Engineer start ======-->
    <div class="modal" id="myModal01">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="career-modal  mx-5 ">Sr. Software Engineer</div>
                </div>
                <div class="modal-body">
                    <div class='page-meta career_popupcontent'>
                        <div class='row'>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>Location:</span> &nbsp; Waterbury - USA
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-2 py-0  w-20'>
                                <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0 w-30'>
                                <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp; April 16,2024
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>End Date:</span> &nbsp; May 1,2024</div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="career_popupcontent">Maganti IT Resources, LLC is looking for 1 full-time (40 hours per
                        week) Sr. Software Engineer for Waterbury, CT location.</div>
                    <div class="global_sub_title job-description mt-4"><b>Job duties</b></div>
                    <div class="career_popupcontent">
                        <ul>
                            <li><strong>1. Software Development:</strong> Lead and participate in the design,
                                development, testing, and deployment of complex software systems and applications.</li>
                            <li><strong>2. Technical Leadership:</strong> Provide technical leadership to the
                                development team, guiding architectural decisions, reviewing code, and mentoring junior
                                engineers.</li>
                            <li><strong>3. Architectural Design:</strong> Design scalable, robust, and maintainable
                                software architectures that meet the project requirements and align with industry best
                                practices.</li>
                            <li><strong>4. Code Review and Quality Assurance:</strong> Conduct thorough code reviews to
                                ensure code quality, performance, and adherence to coding standards. Implement and
                                enforce best practices for software development and quality assurance.</li>
                            <li><strong>5. Problem Solving:</strong> Analyze complex technical problems and propose
                                innovative solutions. Troubleshoot issues in existing software systems and provide
                                timely resolutions.</li>
                            <li><strong>6. Collaboration:</strong> Collaborate effectively with cross-functional teams
                                including product managers, designers, and other engineers to deliver high-quality
                                software solutions.</li>
                            <li><strong>7. Research and Development:</strong> Stay updated with the latest technologies,
                                tools, and trends in software development. Conduct research and experiments to evaluate
                                new technologies and methodologies for potential adoption.</li>
                            <li><strong>8. Documentation:</strong> Create and maintain technical documentation including
                                design documents, API specifications, and system architecture diagrams.</li>
                            <li><strong>9. Performance Optimization:</strong> Identify performance bottlenecks in
                                software systems and optimize code and algorithms for improved performance and
                                scalability.</li>
                            <li><strong>10. Security:</strong> Implement security best practices to ensure the
                                confidentiality, integrity, and availability of sensitive data and systems.</li>
                            <li><strong>11. Continuous Integration and Deployment:</strong> Implement and maintain
                                automated build, test, and deployment pipelines using tools like Jenkins, GitLab CI/CD,
                                or similar technologies.</li>
                            <li><strong>12. Team Collaboration:</strong> Foster a collaborative and positive team
                                environment, contributing to team meetings, knowledge sharing sessions, and continuous
                                improvement initiatives.</li>
                            <li><strong>13. Project Management:</strong> Manage individual tasks and priorities
                                effectively, ensuring timely delivery of high-quality software solutions within project
                                timelines and budget constraints.</li>
                            <li><strong>14. Customer Support:</strong> Provide technical support to customers,
                                addressing their inquiries, troubleshooting issues, and ensuring customer satisfaction
                                with the software product.</li>
                            <li><strong>15. Compliance:</strong> Ensure compliance with regulatory requirements and
                                industry standards relevant to the software domain (e.g., GDPR, HIPAA, ISO standards).
                            </li>
                        </ul>
                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Education Required</b></div>
                    <div class="career_popupcontent">Bachelor of Computer Science or related field required.</div>

                    <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
                    <div class="career_popupcontent">hr&#64;mitresource.com</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!--======Sr Software Engineer Job End ======-->
    <!--======Software Engineer Job start ======-->
    <div class="modal" id="myModal14">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="career-modal  mx-5 ">Software Engineer</div>
                </div>
                <div class="modal-body">
                    <div class='page-meta career_popupcontent'>
                        <div class='row'>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>Location:</span> &nbsp; Waterbury - USA
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-2 py-0  w-20'>
                                <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0 w-30'>
                                <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp; April 16,2024
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>End Date:</span> &nbsp; May 1,2024</div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="career_popupcontent">Maganti IT Resources, LLC is looking for 1 full-time (40 hours per
                        week) Software Engineer.</div>
                    <div class="global_sub_title job-description mt-4"><b>Job duties</b></div>
                    <div class="career_popupcontent">
                        <ul class="bullet-list">
                            <li>Develop and execute test plans, test cases, and test scripts to ensure software quality.
                            </li>
                            <li>· Analyze business requirements, processes, data, and system integration points to
                                determine/recommend appropriate technology solutions.</li>
                            <li>· Analyze information to determine, recommend, and plan the installation of a new system
                                or modification of an existing system.</li>
                            <li>· Address data delivery needs of the clients by designing Restful API to extract
                                information from the MongoDB database.</li>
                            <li>· Collaborate with peer engineers to execute Unit Tests and conduct detailed code
                                reviews of the software.</li>
                            <li>· Successfully collaborate with clients to elicit and gather software requirements.</li>
                            <li>· Prepare reports or correspondence concerning project specifications or status.</li>
                            <li>· Confer with project managers to obtain information on limitations or capabilities for
                                data processing projects.</li>
                            <li>· Create design specifications for high availability and highly scalable applications
                                which will be used by both internal and external customers.</li>
                            <li>· Design, Code, Test, Document, and Deploy global applications based on system and user
                                requirements.</li>
                            <li>· Generate technical documentation as well as a unit and functional tests.</li>
                            <li>· Work with clients and Business Analysts to determine software requirements and system
                                impacts.</li>
                            <li>· Work closely with the global development team, other senior Solution Architects, and
                                executives within the Online Product Engineering group to plan ongoing feature
                                development, product maintenance, and management of development teams.</li>
                            <li>· Work closely with the Enterprise Architects and the development teams through all
                                phases of the SDLC.</li>
                            <li>· Investigate new technologies and techniques and research ongoing industry
                                developments.</li>
                            <li>· Initiate major changes in architecture and software development techniques/processes.
                            </li>
                        </ul>

                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Education Required</b></div>
                    <div class="career_popupcontent">Master of Computer Science or related field.</div>

                    <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
                    <div class="career_popupcontent">hr&#64;mitresource.com</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!--======Software Engineer Job End ======-->
    <!--======.NET Develope Job start ======-->
    <div class="modal" id="myModal15">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="career-modal  mx-5 ">.NET Developer</div>
                </div>
                <div class="modal-body">
                    <div class='page-meta career_popupcontent'>
                        <div class='row'>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>Location:</span> &nbsp; Waterbury - USA
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-2 py-0  w-20'>
                                <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0 w-30'>
                                <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp; April 16,2024
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>End Date:</span> &nbsp; May 1,2024</div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="career_popupcontent">Maganti IT Resources, LLC is looking for 1 full-time (40 hours per
                        week) .NET Developer.</div>
                    <div class="global_sub_title job-description mt-4"><b>Job duties</b></div>
                    <div class="career_popupcontent">
                        <ul class="bullet-list">
                            <li>Develop, implement, and maintain .NET-based applications, web services, and APIs using
                                C#, ASP.NET, MVC, and other related technologies.</li>
                            <li>Design and develop database schema, stored procedures, and SQL queries for data storage
                                and retrieval using Microsoft SQL Server or other database management systems.</li>
                            <li>Collaborate with cross-functional teams to gather and analyze requirements, define
                                project scope, and develop technical specifications.</li>
                            <li>Participate in all phases of the software development lifecycle including requirements
                                analysis, design, coding, testing, debugging, and deployment.</li>
                            <li>Ensure software code quality by adhering to coding standards, conducting code reviews,
                                and implementing best practices for software development.</li>
                            <li>Identify and troubleshoot software defects and performance issues, implementing
                                effective solutions to ensure optimal software functionality.</li>
                            <li>Utilize version control systems such as Git or SVN to manage source code changes and
                                collaborate with team members on code integration.</li>
                            <li>Stay updated with the latest technologies, tools, and trends in .NET development,
                                incorporating new features and capabilities into software projects as appropriate.</li>
                            <li>Provide technical support to end-users, addressing inquiries, resolving issues, and
                                ensuring the successful operation of .NET-based applications.</li>
                            <li>Document software designs, technical specifications, and development processes to
                                facilitate knowledge transfer and project continuity.</li>
                            <li>Adhere to project timelines and milestones, effectively managing individual tasks and
                                priorities to meet project deadlines and deliverables.</li>
                            <li>Collaborate with project managers, business analysts, and other stakeholders to ensure
                                alignment between technical solutions and business requirements.</li>
                            <li>Participate in Agile or Scrum methodologies for project planning, sprint execution, and
                                retrospective meetings.</li>
                            <li>Maintain a proactive approach to learning and professional development, seeking
                                opportunities to enhance skills and expand expertise in .NET development.</li>
                        </ul>

                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Education Required</b></div>
                    <div class="career_popupcontent">Master of Computer Science or related field.</div>

                    <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
                    <div class="career_popupcontent">hr&#64;mitresource.com</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!--======.NET Develope Job End ======-->
    <!--======Cloud Solution Architect Job start ======-->
    <div class="modal" id="myModal16">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="career-modal  mx-5 ">Cloud Solution Architect</div>
                </div>
                <div class="modal-body">
                    <div class='page-meta career_popupcontent'>
                        <div class='row'>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>Location:</span> &nbsp; Waterbury - USA
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-2 py-0  w-20'>
                                <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0 w-30'>
                                <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp; April 16,2024
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>End Date:</span> &nbsp; May 1,2024</div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="career_popupcontent">Maganti IT Resources, LLC is looking for 1 full-time (40 hours per
                        week) Cloud Solution Architect.</div>
                    <div class="global_sub_title job-description mt-4"><b>Job duties</b></div>
                    <div class="career_popupcontent">
                        <ul class="bullet-list">
                            <li>Collaborate with clients, stakeholders, and development teams to understand business
                                requirements and design cloud-based solutions that meet their needs.</li>
                            <li>Assess existing IT infrastructure and applications to identify opportunities for cloud
                                adoption, migration, and optimization.</li>
                            <li>Develop comprehensive cloud architecture designs, including system components,
                                infrastructure, data management, security, scalability, and performance considerations.
                            </li>
                            <li>Recommend cloud technologies, platforms, and services based on business requirements,
                                industry best practices, and cost-effectiveness.</li>
                            <li>Architect and implement hybrid or multi-cloud solutions that leverage the strengths of
                                different cloud providers (e.g., AWS, Azure, Google Cloud) to achieve business
                                objectives.</li>
                            <li>Design and implement cloud-native applications and microservices architectures using
                                containerization technologies such as Docker and orchestration tools like Kubernetes.
                            </li>
                            <li>Define cloud migration strategies and roadmaps, including lift-and-shift,
                                re-platforming, and refactoring approaches, to transition on-premises workloads to the
                                cloud.</li>
                            <li>Ensure compliance with regulatory requirements and industry standards (e.g., GDPR,
                                HIPAA, SOC 2) by implementing appropriate security controls and data protection
                                mechanisms in cloud environments.</li>
                            <li>Collaborate with DevOps teams to implement continuous integration/continuous deployment
                                (CI/CD) pipelines, infrastructure as code (IaC) practices, and automated deployment
                                strategies on cloud platforms.</li>
                            <li>Conduct architecture reviews, performance assessments, and cost optimizations to ensure
                                the efficiency, reliability, and cost-effectiveness of cloud solutions.</li>
                            <li>Provide technical guidance and mentorship to development teams, architects, and other
                                stakeholders on cloud architecture best practices, design patterns, and implementation
                                strategies.</li>
                            <li>Act as a subject matter expert on cloud technologies and trends, staying updated with
                                the latest advancements and evaluating their potential impact on business strategies and
                                solutions.</li>
                            <li>Lead workshops, training sessions, and knowledge-sharing initiatives to disseminate
                                cloud architecture principles, tools, and methodologies across the organization.</li>
                            <li>Collaborate with sales and marketing teams to develop cloud solutions proposals,
                                presentations, and case studies to showcase the value proposition of cloud services to
                                prospective clients.</li>
                            <li>Participate in pre-sales activities, including client meetings, solution demonstrations,
                                and technical discussions, to help shape cloud solutions and address customer inquiries.
                            </li>
                        </ul>
                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Education Required</b></div>
                    <div class="career_popupcontent">Bachelor Computer Science or related field.</div>
                    <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
                    <div class="career_popupcontent">hr&#64;mitresource.com</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!--======Cloud Solution Architect Job End ======-->
    <!--======Sr. UI Engineer Job start ======-->
    <div class="modal" id="myModal17">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="career-modal mx-5 ">Sr. UI Engineer</div>
                </div>
                <div class="modal-body">
                    <div class='page-meta career_popupcontent'>
                        <div class='row'>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>Location:</span> &nbsp; Waterbury - USA
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-2 py-0  w-20'>
                                <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0 w-30'>
                                <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp; April 16,2024
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>End Date:</span> &nbsp; May 1,2024</div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="career_popupcontent">Maganti IT Resources, LLC is looking for 1 full-time (40 hours per
                        week) Sr. UI Engineer.</div>
                    <div class="global_sub_title job-description mt-4"><b>Job duties</b></div>
                    <div class="career_popupcontent">
                        <ul class="bullet-list">
                            <li>Lead the design and development of user interfaces for web applications, ensuring
                                high-quality, responsive, and intuitive user experiences.</li>
                            <li>Collaborate with product managers, designers, and other stakeholders to gather
                                requirements and translate them into technical specifications and UI designs.</li>
                            <li>Architect, implement, and maintain front-end codebases using modern web technologies
                                such as HTML5, CSS3, JavaScript, and frameworks/libraries like React.js, Angular, or
                                Vue.js.</li>
                            <li>Develop reusable UI components and libraries to streamline development processes and
                                promote code maintainability and scalability.</li>
                            <li>Implement responsive design principles and cross-browser compatibility to ensure
                                consistent performance and accessibility across various devices and platforms.</li>
                            <li>Optimize web applications for performance and speed, leveraging techniques such as code
                                splitting, lazy loading, and caching to enhance user experience.</li>
                            <li>Conduct code reviews and provide constructive feedback to junior engineers to ensure
                                code quality, consistency, and adherence to best practices and design patterns.</li>
                            <li>Stay updated with emerging trends and technologies in front-end development, evaluating
                                and integrating new tools and frameworks to enhance development workflows and
                                capabilities.</li>
                            <li>Collaborate with back-end developers to integrate front-end components with server-side
                                logic and data sources, ensuring seamless communication and data exchange between the
                                client and server.</li>
                            <li>Implement and maintain automated testing processes for front-end code, including unit
                                tests, integration tests, and end-to-end tests, using tools like Jest, Mocha, or
                                Selenium.</li>
                            <li>Work closely with UX/UI designers to iterate on design prototypes and wireframes,
                                providing technical insights and feasibility assessments to refine the user interface
                                design.</li>
                            <li>Provide technical leadership and mentorship to junior UI engineers, fostering a culture
                                of collaboration, continuous learning, and innovation within the front-end development
                                team.</li>
                            <li>Document technical designs, implementation details, and best practices to facilitate
                                knowledge sharing and onboarding of new team members.</li>
                            <li>Participate in Agile or Scrum methodologies for project planning, sprint execution, and
                                retrospective meetings, contributing to the continuous improvement of development
                                processes and workflows.</li>
                        </ul>
                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Education Required</b></div>
                    <div class="career_popupcontent">Bachelor Computer Science or related field.</div>

                    <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
                    <div class="career_popupcontent">hr&#64;mitresource.com</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!--======Sr. UI Engineer Job End ======-->
    <!--======Application Integration EngineerJob start ======-->
    <div class="modal" id="myModal19">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="career-modal  mx-5 ">Application Integration Engineer</div>
                </div>
                <div class="modal-body">
                    <div class='page-meta career_popupcontent'>
                        <div class='row'>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>Location:</span> &nbsp; Waterbury - USA
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-2 py-0  w-20'>
                                <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0 w-30'>
                                <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp; April 16,2024
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>End Date:</span> &nbsp; May 1,2024</div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="career_popupcontent">Maganti IT Resources, LLC is looking for 1 full-time (40 hours per
                        week) Application Integration Engineer.</div>
                    <div class="global_sub_title job-description mt-4"><b>Job duties</b></div>
                    <div class="career_popupcontent">
                        <ul class="bullet-list">
                            <li><strong>Integration Strategy:</strong> Develop integration strategies and solutions to
                                connect various software applications and systems within an organization, ensuring
                                seamless data flow and interoperability.</li>
                            <li><strong>System Analysis:</strong> Analyze existing software systems, databases, and APIs
                                to identify integration points, data exchange requirements, and potential integration
                                challenges.</li>
                            <li><strong>Design and Architecture:</strong> Design integration architectures and data
                                models that support efficient and scalable data exchange between different applications,
                                services, and platforms.</li>
                            <li><strong>Integration Technologies:</strong> Implement integration solutions using
                                middleware platforms, enterprise service buses (ESB), message queues, API gateways, and
                                other integration tools and technologies.</li>
                            <li><strong>API Development:</strong> Develop and maintain RESTful APIs, SOAP services, and
                                other web services to facilitate data communication and integration between disparate
                                systems.</li>
                            <li><strong>Data Mapping and Transformation:</strong> Define data mapping rules and
                                transformation logic to convert data formats, structures, and protocols between
                                different systems, ensuring data accuracy and consistency.</li>
                            <li><strong>Message Routing and Orchestration:</strong> Configure message routing rules and
                                orchestration workflows to govern the flow of data between integrated systems and manage
                                message processing logic.</li>
                            <li><strong>Error Handling and Monitoring:</strong> Implement error handling mechanisms,
                                logging, and monitoring solutions to track integration errors, exceptions, and
                                performance metrics, ensuring timely resolution and optimization.</li>
                            <li><strong>Security and Compliance:</strong> Implement security controls, authentication
                                mechanisms, and data encryption techniques to ensure the confidentiality, integrity, and
                                availability of data exchanged between integrated systems. Ensure compliance with
                                regulatory requirements and industry standards (e.g., GDPR, HIPAA).</li>
                            <li><strong>Testing and Validation:</strong> Develop test plans and perform integration
                                testing to validate the functionality, performance, and reliability of integration
                                solutions. Conduct regression testing and troubleshooting to identify and resolve
                                integration issues.</li>
                            <li><strong>Documentation and Knowledge Sharing:</strong> Create and maintain technical
                                documentation, including integration specifications, data mappings, configuration
                                guides, and troubleshooting procedures. Share knowledge and best practices with
                                development teams, stakeholders, and support personnel.</li>
                            <li><strong>Collaboration and Communication:</strong> Collaborate with cross-functional
                                teams, including software developers, system administrators, business analysts, and
                                project managers, to align integration solutions with business requirements and project
                                objectives. Communicate effectively with stakeholders to gather requirements, provide
                                status updates, and address concerns.</li>
                            <li><strong>Continuous Improvement:</strong> Identify opportunities for process improvement,
                                automation, and optimization in integration workflows and technologies. Stay updated
                                with emerging integration technologies and industry trends to enhance integration
                                capabilities and efficiency.</li>
                        </ul>
                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Education Required</b></div>
                    <div class="career_popupcontent">Bachelor Computer Science or related field.</div>

                    <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
                    <div class="career_popupcontent">hr&#64;mitresource.com</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!--======Application Integration Engineer End ======-->
    <!--======>Sr. .NET Developer Job start ======-->
    <div class="modal" id="myModal25">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="career-modal  mx-5 ">Quality Assurance Analyst</div>
                </div>
                <div class="modal-body">
                    <div class='page-meta career_popupcontent'>
                        <div class='row'>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>Location:</span> &nbsp; Waterbury - USA
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-2 py-0  w-20'>
                                <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0 w-30'>
                                <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp; July 31,2024
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>End Date:</span> &nbsp; August 15,2024
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="career_popupcontent">Maganti IT Resources LLC is seeking one professional for the
                        full-time position of a Quality Assurance Analyst.</div>
                    <div class="global_sub_title job-description mt-4"><b>Job duties</b></div>
                    <div class="career_popupcontent">
                        <ul class="bullet-list">
                            <li>Develop and execute test plans, test cases, and test scripts to ensure software quality.
                            </li>
                            <li>Perform functional, regression, and integration testing on software applications.</li>
                            <li>Identify, isolate, and document software defects in a clear and concise manner.</li>
                            <li>Collaborate with cross-functional teams to ensure timely resolution of issues.</li>
                            <li>Participate in requirement analysis and review meetings to ensure test coverage.</li>
                            <li>Utilize automated testing tools and frameworks to streamline testing processes.</li>
                            <li>Maintain test documentation and contribute to the improvement of QA processes.</li>
                            <li>Conduct performance and scalability testing as required.</li>
                            <li>Provide accurate and timely status reports on testing progress and issues encountered.
                            </li>
                            <li>Stay updated with industry trends and best practices in software quality assurance.</li>
                        </ul>
                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Education Required</b></div>
                    <div class="career_popupcontent"> Bachelor of Computer Science or related field required.
                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
                    <div class="career_popupcontent">hr&#64;mitresource.com</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!--======>Sr. .NET Developer End ======-->
    <div class="modal" id="myModal28">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="career-modal global_sub_title mx-5 ">Sr. Technical Consultant</div>
                </div>
                <div class="modal-body">
                    <div class='page-meta career_popupcontent'>
                        <div class='row'>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>Location:</span> &nbsp; Waterbury - USA
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-2 py-0  w-20'>
                                <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0 w-30'>
                                <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp; October 22,2024
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>End Date:</span> &nbsp; November 07,2024
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="career_popupcontent">Maganti IT Resources LLC is seeking one professional for the
                        full-time position of a Sr. Technical Consultant(SharePoint).</div>
                    <div class="global_sub_title job-description mt-4"><b>Job duties</b></div>
                    <div class="career_popupcontent">
                        <ul class="bullet-list">
                            <li>Work as a Sr Technical Consultant for PowerPlatform/Microsoft365 including&nbsp;Adoption
                                and Training.</li>
                            <li>Functions as a technical expert to recommend IT policies/systems for implementation of
                                Microsoft365.</li>
                            <li>Develop and prototype solutions to meet customer requirements and and test the solution
                                including workflows.</li>
                            <li> Create technical support documentation.</li>
                            <li> Serves as technical advisor to management and identifying solutions to complex
                                technical
                                problems in regard to PowerPlatform, Microsoft Dynamics365, SharePoint, Teams and
                                Microsoft 365.</li>
                            <li>Work on Modernizing legacy systems,modernizing the infrastructure and migration to cloud
                                which are critical to US EEOC mission.</li>

                        </ul>
                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Skills</b></div>
                    <div class="career_popupcontent">
                        Conversant with Microsoft365 and PowerPlatform and is able to translate technical jargon into
                        layman's terms for explanatory purposes. Strong troubleshooting skills. Able to help
                        troubleshoot complex system issues. Strategic thinker and planner with demonstrated analytical
                        problem solving skills in demanding environments. Strong leader and mentor, proven team builder,
                        possessing excellent communication and interpersonal skills.

                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Education Required</b></div>
                    <div class="career_popupcontent">The minimum educational qualification for this position is Bachelor
                        of Computer Science or related field.
                    </div>

                    <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
                    <div class="career_popupcontent">hr&#64;mitresource.com</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!--======>DevOps Engineer End ======-->
    <!--======>Java Developer Job start ======-->
    <div class="modal" id="myModalJava">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="career-modal global_sub_title mx-5 ">Java Developer</div>
                </div>
                <div class="modal-body">
                    <div class='page-meta career_popupcontent'>
                        <div class='row'>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>Location:</span> &nbsp; Waterbury - USA
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-2 py-0  w-20'>
                                <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0 w-30'>
                                <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp; November 15,2024
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>End Date:</span> &nbsp; December 3,2024
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="career_popupcontent">Maganti Group, LLC is seeking one professional for Full-time
                        employment (40 hours a week) for the position of a JAVA Developer at a competitive salary.</div>
                    <div class="global_sub_title job-description mt-4"><b>Job duties</b></div>
                    <div class="career_popupcontent">
                         Involve in daily Agile Methodologies and scrum implemented meetings and sprint planning’s and
                        create technical documents based on epics as we complete the stories; Design and develop
                        applications using Core Java Concepts like OOPs, Multi-Threading, Exception Handling,
                        Collections, Generics and Multi-Processing; Responsible for designing, coding, documenting, and
                        deploying global applications based on system and user requirements; Work on Building Automation
                        and Continuous Integration tools like Jenkins, ANT, Maven, Putty, Jira; Creates design
                        specifications for high availability and highly scalable applications which will be used by both
                        internal and external customers; Works with clients and business analysts to determine software
                        requirements and system impacts.
                    </div>

                    <div class="global_sub_title job-description  mt-4"><b>Education Required</b></div>
                    <div class="career_popupcontent"> The minimum educational qualification for this position is Master
                        of Computer Science or its closely related field.
                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
                    <div class="career_popupcontent"> ATTN: HR, Maganti Group, LLC, 21 State St, Waterbury, CT 06702
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!--======>Java Developer End ======-->
    <!--======>Engineer DevOps Job start ======-->
    <div class="modal" id="myModalEngineerDevops">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="career-modal global_sub_title  mx-5 ">Engineering Manager, DevOps</div>
                </div>
                <div class="modal-body">
                    <div class='page-meta career_popupcontent'>
                        <div class='row'>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>Location:</span> &nbsp; Waterbury - USA
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-2 py-0  w-20'>
                                <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0 w-30'>
                                <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp; December 6,2024
                                </div>
                            </div>
                            <div class='col-xs-12 col-sm-3 py-0'>
                                <div><span class='c-orange job-career-title'>End Date:</span> &nbsp; December 23,2024
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="career_popupcontent">Maganti IT Resources LLC is seeking one professional employment
                        with 40 hours a week for the position of Engineering Manager, DevOps at a competitive salary.
                    </div>
                    <div class="global_sub_title job-description mt-4"><b>Job duties include (but not limited to)</b>
                    </div>
                    <div class="career_popupcontent">
                        <ul class="bullet-list">
                            <li>Lead and manage the DevOps engineering team to ensure high performance and efficient
                                delivery of software and infrastructure solutions.</li>
                            <li>Evaluate and select technologies and third-party services to support business
                                objectives.
                            </li>
                            <li> Collaborate with product, engineering, and operations teams to define and implement
                                scalable infrastructure solutions.</li>
                            <li>Drive the adoption of best practices for infrastructure such as code, automation, and
                                configuration management.</li>
                            <li>Mentor and coach team members, fostering their growth and development in technical
                                skills and leadership abilities.</li>
                            <li> Develop and enforce security practices in the software development lifecycle and
                                infrastructure management.</li>
                            <li> Foster a culture of collaboration, innovation, and accountability.</li>
                            <li> Manage performance reviews, career growth, and skill development.</li>
                            <li>Write development plans for individuals in the team for a focused career growth.</li>
                            <li>Define and implement DevOps strategies aligned with organizational goals.</li>
                            <li>Drive automation and modernization initiatives across development and operations
                                processes.</li>
                            <li>Analyze system performance metrics and proactively identify opportunities for
                                improvement.</li>
                            <li>Ensure that the team adheres to timelines, project goals, and budget constraints while
                                delivering high-quality results.</li>
                            <li>Stay updated with industry trends and integrate new tools and technologies to
                                continuously improve the DevOps processes.</li>
                            <li>Build and maintain strong cross-functional relationships to ensure smooth collaboration
                                and alignment of engineering objectives.</li>
                        </ul>
                    </div>
                    <div class="global_sub_title job-description  mt-4"><b>Educational requirement</b></div>
                    <div class="career_popupcontent">Bachelor of Technology or related field</div>

                    <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
                    <div class="career_popupcontent">Maganti IT Resources, LLC, 21 State St, Waterbury, CT 06702
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!--======>Engineer DevOps Job start ======-->

    <!--====== Careers Carousel section starts ======-->
    <div id="main-wrapper">
        <div class="site-wrapper-reveal">
            <div class="flexible-image-slider-wrapper">
                <div class="row rowsizes">
                    <div class="col-lg-12 col-sm-12 rowsizes">
                        <div class="flexible-image-slider-wrap">
                            <swiper-container class="trainingcarousel_mainheading single-flexible__container"
                                slidesPerView="1" [autoplay]="false" loop="true" navigation="true" pagination="false">
                                <swiper-slide>

                                    <div class="training_carouselmainbgcolor carousel_mainheadingsection">
                                        <h3 class="text-center text-white global_section_header">Success
                                            stories from our learners
                                        </h3>
                                        <div class="row bg-white">
                                            <div class="col-md-6 col-lg-6 p-0">
                                                <!-- Single flexible slider Start -->
                                                <div class="training_carouselmainimage">
                                                    <div class="single-flexible-slider techtraining_image">
                                                        <img src="../../../assets/images/techtraining_images/training_carouselimg.png"
                                                            class="techtraining_carouselimg" width="100%" height="100%"
                                                            alt="training carousel img" />
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- Single flexible slider End -->
                                            <div class=" col-md-5 col-lg-6">
                                                <div class="training_carouselmaincontent">
                                                    <div class=" CAREER-SLIDE text-center global_sub_title text-black"
                                                        role="heading" aria-level="1">
                                                        Application Developer</div>
                                                    <div class="training_subtext global_section_content mt-5">
                                                        If a house has strong foundation and pillars, the house
                                                        stands the test of time. My experience with Maganti IT
                                                        Resources, LLC has been akin to that. I have been working
                                                        with them since 2017. After my graduation, I was lucky
                                                        enough to find an employer such as Maganti IT who guided me
                                                        through each and every step to become a software
                                                        professional. They are always there for me just like a
                                                        family. I strongly recommend my employer as an option to
                                                        those individuals who are looking for a right guidance to
                                                        establish their career in their respective fields.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </swiper-slide>
                                <swiper-slide>
                                    <div class="training_carouselmainbgcolor carousel_mainheadingsection">
                                        <h3 class="text-center text-white global_section_header">Success
                                            stories from our learners
                                        </h3>
                                        <div class="row bg-white">
                                            <div class="col-md-5 col-lg-6 p-0">
                                                <!-- Single flexible slider Start -->
                                                <div class="training_carouselmainimage p-0">
                                                    <div class="single-flexible-slider techtraining_image ">
                                                        <img src="../../../assets/images/career/career-carousel-image.png"
                                                            class="techtraining_carouselimg" width="100%" height="100%"
                                                            alt="career-carousel-image" />
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- Single flexible slider End -->
                                            <div class="col-md-5 col-lg-6 ">
                                                <div class="training_carouselmaincontent">
                                                    <div
                                                        class=" CAREER-SLIDE  text-center global_sub_title text-black mt-5">
                                                        Kishore V, Project Manager
                                                    </div>
                                                    <div
                                                        class="training_subtext global_section_content text-black mt-5">
                                                        I worked for Maganti IT Resources, LLC for over for 6 years
                                                        and so far, the experience had been nothing less than
                                                        amazing. I can concentrate on the work and need not worry
                                                        about anything- everything from visa filing- paycheck-
                                                        support, everything found to be seamless. The Owner and the
                                                        staff, especially HR were very professional and courteous in
                                                        any matter I brought up with and tend to resolve quickly and
                                                        amicably. I'd highly recommend MIT for any consultants that
                                                        look for good employer for Visa jobs/ Green Card filing to
                                                        any project delivery in a timely manner.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </swiper-slide>
                            </swiper-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br />
    <!--====== Careers Carousel section end ======-->
</div>
<div class="modal" id="modalSeniorDotNet">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <div class="career-modal global_sub_title  mx-5 ">DotNet Developer</div>
            </div>
            <div class="modal-body">
                <div class='page-meta career_popupcontent'>
                    <div class='row'>
                        <div class='col-xs-12 col-sm-3 py-0'>
                            <div><span class='c-orange job-career-title'>Location:</span> &nbsp; Waterbury - USA
                            </div>
                        </div>
                        <div class='col-xs-12 col-sm-2 py-0  w-20'>
                            <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                        </div>
                        <div class='col-xs-12 col-sm-3 py-0 w-30'>
                            <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp; April 30,2025
                            </div>
                        </div>
                        <div class='col-xs-12 col-sm-3 py-0'>
                            <div><span class='c-orange job-career-title'>End Date:</span> &nbsp; May 15,2025</div>
                        </div>
                    </div>
                </div>
                <hr />
                <div class="career_popupcontent">Maganti IT Resources LLC is seeking one professional for a 
                    full-time employment (40 hours a week) for the position of Sr. DotNet Developer at competitive salary.</div>
                <div class="global_sub_title job-description mt-4"><b>Job duties include (but not limited to): </b>
                </div>
                <div class="career_popupcontent pt-2">
                    <ul class="bullet-list">
                        <li>Design and build Eligibility and claim functionality of the application from scratch.
                        </li>
                        <li>Architect, design, and develop high-quality, scalable, and secure .NET applications to support DMV operations. </li>
                        <li>Work on major functionality of the application.  </li>
                        <li> Maintain session values for key objects of the application, follow SOLID principles and design the application.
                         </li>
                        <li>Develop and execute unit tests, integration tests, and debugging procedures to ensure software quality and reliability.

                        </li>
                        <li> Create Models, Views, and Controllers for the application; Provide ongoing maintenance, support, and enhancements for existing applications to ensure optimal performance and reliability.
                        </li>
                        <li> Understand legacy applications build on Classic ASPX, the flow of code, and stored procedures used in the application. </li>
                        <li>Rewrite the legacy application into .NET CORE MVC6 using Bootstrap UI for responsive pages.
                         </li>
                        <li>Use different available Bootstrap classes to design more responsive pages that fit all screen sizes available. </li>
                        <li>Convert data from the database into JSON format files and retrieve useful information using AJAX calls to render the response in UI.
                        </li>
                        <li>Develop all the UI pages using extensive markup and scripting languages (HTMCSS HTMLTML, JavaScript, and CSS). </li>
                        <li>
                            Develop AJAX base web base UI framework by utilizing the JQUERY library.
                        </li>
                        <li>Educate in device-neutral design incorporating responsive techniques employing the use of CSS3 and JavaScript.</li>
                        <li>Utilize knowledge in HTML5 and CSS3 for a responsive design for site appearance and functionality across all major devices and browsers. 
                        </li>
                        <li>Write a clean code to retrieve data for Look-up available in the application.
                        </li>
                        <li>Write LINQ queries to get the data from the Manager class and bind it to Views.
                        </li>
                        <li>Design  UI layout using HTML, CSS, JS, and Bootstrap.
                        </li>
                        <li>Work on AJAX calls to retrieve data in the form of a Data table.
                        </li>
                        <li>Work with BA and QA team to understand the business layer and develop the application accordingly.
                        </li>
                        <li>
                            Help the QA team in testing and code reviews.
                        </li>
                    </ul>
                </div>
                <div class="global_sub_title job-description  mt-4"><b>Education required</b></div>
                <div class="career_popupcontent">  Bachelor of Computer Science or a related field.</div>

                <div class="global_sub_title job-description  mt-4"><b>Send your resume to</b></div>
                <div class="career_popupcontent">ATTN: HR, Maganti IT Resources, LLC, 21 State St, Waterbury, CT 06702

                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>
<div class="modal" id="Softwarejobpost">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <div class="career-modal  global_sub_title mx-5 "> Software Developer</div>
            </div>
            <div class="modal-body">
                <div class='page-meta career_popupcontent'>
                    <div class='row'>
                        <div class='col-xs-12 col-sm-3 py-0'>
                            <div><span class='c-orange job-career-title'>Location:</span> &nbsp; Waterbury - USA
                            </div>
                        </div>
                        <div class='col-xs-12 col-sm-2 py-0  w-20'>
                            <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                        </div>
                        <div class='col-xs-12 col-sm-3 py-0 w-30'>
                            <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp; May 12, 2025
                            </div>
                        </div>
                        <div class='col-xs-12 col-sm-3 py-0'>
                            <div><span class='c-orange job-career-title'>End Date:</span> &nbsp; May 29, 2025</div>
                        </div>
                    </div>
                </div>
                <hr />
                <div class="career_popupcontent">Maganti IT Resources LLC is seeking one professional for a fulltime
                    employment (40 hours/week) for a Software Developer position at Waterbury, CT.</div>
                <div class="global_sub_title job-description mt-4"><b>Job duties</b></div>
                <div class="career_popupcontent">A strong and versatile Software Developer involved in
                     majority of Software Development Life Cycle phases to build Web
                     Applications and Software components for users.</div>
                <div class="career_popupcontent">
                    <ul class="bullet-list">
                    
                        <li> Review and evaluate design and project activities with Product owner for compliance with systems design and development guidelines and standards.
                             Provide tangible feedback to improve product quality and mitigate failure risk.</li>
                        <li> Work with cross functional teams  to create joint solutions.</li>
                        <li> Work on data storage solutions that includes databases, key-value stores, blob stores, etc.</li>
                        <li>Coordinate with User Experience (UX) team to integrate User Interface (UI) with REST API Service layer.</li>
                       <li> Identify application performance bottlenecks and bugs and provide solutions to these problems.</li>
                       <li>Maintain code quality following coding standards, organization and automatization.</li>
                       <li>Work with Continuous Integration and Continuous Deployment (CICD) pipelines to deploy applications to multiple server environments.</li>
                       <li>Design and develop efficient data models, able to optimize SQL queries for application performance.</li>
                       <li>Develop REST API interface to encapsulate business services and technology services for database and third-party services.</li>
                       <li> Coordinate with Infrastructure team to provide the application specific information to setup different environments - Development, QA and Production servers.</li>
                       <li>Coordinate with Web Security team to implement Single Sign On to enable application users utilize one set credentials.</li>
                       <li>Develop User Interface using frameworks HTML, JSP, Bootstrap, JQuery, JavaScript, Ajax and CSS.</li>
                       <li> Implement client-side validations and interactive connections between UI and REST API services as controllers to fetch data objects from Back End to UI.</li>
                       <li>Responsible to create EJB projects to invoke Data Access layers and create business objects after implementing all business logics. [Core Java – 1.8]

                       </li>
                       <li>Document High Level and Detail Design documents capturing all the technical details of the web application.</li>
                       
                        
                    </ul>
                </div>
                <div class="global_sub_title job-description  mt-4"><b>Education Required</b></div>
                <div class="career_popupcontent"> Bachelor of Computer Science or related field</div>
                <div class="global_sub_title job-description  mt-4"><b>Send your resume to</b></div>
                <div class="career_popupcontent">Maganti IT Resources, LLC, 21 State St, Waterbury, CT 06702</div>
            </div>
            <div class="modal-footer">
                <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>
<div class="modal" id="uiDeveloper">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <div class="career-modal  global_sub_title mx-5 "> UI Developer</div>
            </div>
            <div class="modal-body">
                <div class='page-meta career_popupcontent'>
                    <div class='row'>
                        <div class='col-xs-12 col-sm-3 py-0'>
                            <div><span class='c-orange job-career-title'>Location:</span> &nbsp; Waterbury - USA
                            </div>
                        </div>
                        <div class='col-xs-12 col-sm-2 py-0  w-20'>
                            <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                        </div>
                        <div class='col-xs-12 col-sm-3 py-0 w-30'>
                            <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp; May 20, 2025
                            </div>
                        </div>
                        <div class='col-xs-12 col-sm-3 py-0'>
                            <div><span class='c-orange job-career-title'>End Date:</span> &nbsp; June 4, 2025</div>
                        </div>
                    </div>
                </div>
                <hr />
                <div class="career_popupcontent">Maganti IT Resources LLC is seeking one professional for a fulltime employment (40 hours/week) for a UI Developer position at Waterbury, CT.</div>
                <div class="global_sub_title job-description mt-4"><b>Job duties</b></div>
                <div class="career_popupcontent">A strong and versatile UI Developer involved in majority of Software Development Life Cycle phases to build Web Applications and Software components for users.</div>
                <div class="career_popupcontent">
                    <ul class="bullet-list">
                    
                        <li> Review and evaluate design and project activities with Product owner for compliance with systems design and development guidelines and standards.
                             Provide tangible feedback to improve product quality and mitigate failure risk.</li>
                        <li> Work with cross functional teams  to create joint solutions.</li>
                        <li> Work on data storage solutions that includes databases, key-value stores, blob stores, etc.</li>
                        <li>Coordinate with User Experience (UX) team to integrate User Interface (UI) with REST API Service layer.</li>
                       <li> Identify application performance bottlenecks and bugs and provide solutions to these problems.</li>
                       <li>Maintain code quality following coding standards, organization and automatization.</li>
                       <li>Work with Continuous Integration and Continuous Deployment (CICD) pipelines to deploy applications to multiple server environments.</li>
                       <li>Design and develop efficient data models, able to optimize SQL queries for application performance.</li>
                       <li>Develop REST API interface to encapsulate business services and technology services for database and third-party services.</li>
                       <li> Coordinate with Infrastructure team to provide the application specific information to setup different environments - Development, QA and Production servers.</li>
                       <li>Coordinate with Web Security team to implement Single Sign On to enable application users utilize one set credentials.</li>
                       <li>Develop User Interface using frameworks HTML, JSP, Bootstrap, JQuery, JavaScript, Ajax and CSS.</li>
                       <li> Implement client-side validations and interactive connections between UI and REST API services as controllers to fetch data objects from Back End to UI.</li>
                       <li>Responsible to create EJB projects to invoke Data Access layers and create business objects after implementing all business logics. [Core Java – 1.8]

                       </li>
                       <li>Document High Level and Detail Design documents capturing all the technical details of the web application.</li>
                       
                        
                    </ul>
                </div>
                <div class="global_sub_title job-description  mt-4"><b>Education Required</b></div>
                <div class="career_popupcontent"> Bachelor of Computer Science or related field</div>
                <div class="global_sub_title job-description  mt-4"><b>Send your resume to</b></div>
                <div class="career_popupcontent">Maganti IT Resources, LLC, 21 State St, Waterbury, CT 06702</div>
            </div>
            <div class="modal-footer">
                <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>